import {
	Component,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	OnDestroy,
	AfterViewInit,
	ElementRef,
	ContentChild,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { EngageCarriersDialogComponent } from '../engage-carriers-dialog/engage-carriers-dialog.component';
import { EMAIL_VALIDATED_TOOLTIP } from '../../cargo-chief-commons/contact/utils';

import { Store, select } from '@ngrx/store';

import { ActivatedRoute, Router } from '@angular/router';
import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UtilService } from '@service/util/util.service';
import {
	ContactsTable,
	HQ_LOCATION_PARSER,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	NOTIFICATION_TYPES,
	ProjectCarrierMapDTO,
	ProjectDTO,
	RestService,
	PROJECT_CARRIER_MAP_STATUS,
	ProjectGroup,
	IS_EMPTY,
	Owner,
	INTEGRATION_TYPE,
	FORMAT_SCORE_PERCENTAGE,
} from 'cargo-chief-commons';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { UserSettingsService } from '@service/userSettings/user-settings.service';
import {
	CARGOCHIEF_KEYS,
	CARRIER_FEEDBACK_SETTINGS,
	MIN_PAGE_CONTAINER_WIDTH,
	MIN_WIDTH_CONTAINER_CLASS,
	CAPACITY_SEARCH_FILTER,
	RANGE_FILTERS,
	QUALITY_FILTER_OPTIONS,
	QUALITY_SCORE_DISPLAY,
	PROCUREMENT_VERSION,
} from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { FirebaseService } from '@service/firebase/firebase.service';
import { SharedService } from '@service/shared/shared.service';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { CarrierSearchHelperService } from '@core/services/carrier-search-helper/carrier-search-helper.service';
import { environment } from '@environment/environment';
import { ProjectDetailsService } from '@service/projectDetails/project-details.service';
import { PricingFeedbackService } from '@service/pricingFeedback/pricing-feedback.service';
import { CapacitySearchFilterService } from '@service/capacitySearchFilter/capacity-search-filter.service';
import { PricingComponent } from '@shared/pricing/pricing.component';
import { RecommendedCarriersComponent } from '../recommended-carriers/recommended-carriers.component';
import { NotesService } from '@service/notesService/notes.service';
import { NoteListComponent, NoteType } from '@notes/note-list/note-list.component';
import { ProductsService } from '@service/products/products.service';
import { AccessCacheService } from '@service/access-cache/access-cache.service';
import { ProcuredCarriersComponent } from '../procured-carriers/procured-carriers.component';
import { AllocatedCarriersComponent } from '../allocated-carriers/allocated-carriers.component';
import { BaseComponent } from '@shared/base/base.component';
import { RESOLVE_EFFECTIVE_CC_SCORE } from '@shared/utils/quality-data-utils';
import { takeUntil, take, distinctUntilChanged, skip, map, debounceTime } from 'rxjs/operators';
import { firstValueFrom, BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { CapacitySearchFilterComponent } from '../capacity-search-panel/capacity-search-filter/capacity-search-filter.component';
import { ProjectGroupsComponent } from '../project-groups/project-groups.component';

import { ProjectDetailsStore } from '../store/store/project-details.store';
import { RecommendedCarriersStore } from '../store/store/recommended-carriers-store';
import {
	RECOMMENDED_CARRIERS,
	PROJECT_GROUPS,
	PROJECT_CARRIER_MAP,
	PROJECT_DETAILS,
} from '../store/actions';
import { projectDetailsPageStateKey, ProjectDetailsState } from '../store/state';
import { AddToGroupComponent } from '../add-to-group/add-to-group.component';

import { Actions, ofType } from '@ngrx/effects';
import { ProjectDetailsEffects } from '../store/effects/project-details.effects';
import { RecommendedCarriersEffects } from '../store/effects/recommended-carriers.effects';
import { ERROR_HANDLING } from '../../store/actions/error-handling.actions';
import { ACTIVE_USERS, ALL_ACCOUNT_USERS } from '@shared/utils/account-users';
import { IntegrationService } from '@service/integration/integration.service';
import { BookingAssistantService } from '@service/booking-assistant/booking-assistant.service';
import { BaConfigService } from '@service/baConfig/ba-config.service';
import { ProjectGroupService } from '@service/project-group/project-group.service';
import { PROJECT_TYPES, IS_WORKFLOW_PROJECT_TYPE } from '@domain/constants/project-types';

const NOTIFICATION_NAME = 'notification.name';

@Component({
	selector: 'app-project-details',
	templateUrl: './project-details.component.html',
	styleUrls: ['./project-details.component.scss'],
	providers: [CurrencyPipe],
	encapsulation: ViewEncapsulation.None,
})
export class ProjectDetailsComponent
	extends BaseComponent
	implements OnInit, OnDestroy, AfterViewInit
{
	@ViewChild('pricingComponent') pricingComponent: PricingComponent;
	@ViewChild('recommendedCarriersComponent')
	recommendedCarriersComponent: RecommendedCarriersComponent;
	@ViewChild('procuredCarriersComponent') procuredCarriersComponent: ProcuredCarriersComponent;
	@ViewChild('engagedCarriersComponent') engagedCarriersComponent: ProcuredCarriersComponent;
	@ViewChild('allocatedCarriersComponent') allocatedCarriersComponent: AllocatedCarriersComponent;

	// CN-8312 V2: client-side sort field for the Engaged + Procured tabs.
	// Uses the same string values as Recommended (RANGE_FILTERS.SORT.MATCH / FREQUENCY / QUALITY)
	// so the SORT dropdown is consistent across all three carrier tabs.
	engagedProcuredSort$ = new BehaviorSubject<string>('match');
	engagedProcuredSort: string = 'match';
	@ViewChild('appCapacitySearchFilter') appCapacitySearchFilter: CapacitySearchFilterComponent;
	@ViewChild('projectGroups') projectGroupsComponent: ProjectGroupsComponent;
	// CN-8312: the V3 Carrier-tray carrier note list, so a logged call can insert
	// the created note immediately (lag-free) instead of waiting on a re-fetch.
	@ViewChild('trayCarrierNoteList') trayCarrierNoteList: NoteListComponent;

	@ViewChild('projectDetailsAndPricingContainer')
	projectDetailsAndPricingContainer: ElementRef<HTMLDivElement>;
	@ViewChild('pageContentContainer')
	pageContentContainer: ElementRef<HTMLDivElement>;

	projectId: string = null;
	projectDTO: ProjectDTO = null;
	projectCarrierMapList: Array<ProjectCarrierMapDTO> = [];

	PAGE = 0;
	// PAGE_SIZE = 10;
	carrierIds: Array<string> = null;
	isLaneDetailsProfileView: boolean = false;
	carrierLaneData: any = null;
	recentFeedbackList: any = null;
	contactList: ContactsTable[] = null;
	// CN-8312: full contact list for the focused carrier shown in the V3 Carrier
	// tray Contacts section. Kept separate from `contactList` (lane-details
	// full-profile view) so the two don't clobber each other. null = loading.
	trayContactList: ContactsTable[] = null;
	trayContactsCarrierId: string = null;
	// CN-8312: client-side "Validated only" filter for the Carrier-tray Contacts
	// section — filters the already-loaded trayContactList, no server round-trip.
	showValidatedContactsOnly: boolean = false;
	customerOnly: boolean = false;
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	CARRIER_QUALITY_ENABLED!: boolean;

	totalNumberOfTasks: any;
	totalNumberOfNotes: any;
	// CN-8312: Trigger to refresh notes list after engage
	notesRefreshTrigger: number = 0;

	NUMBER_OF_LANES: number = 0;

	selectedProjectCarrierMapIDs: Array<string> = [];
	selectedAllocatedCarrierMapIDs: Array<string> = [];

	tooltipMessage =
		'mc - a valid mc number (eg. mc:12345 or mc-12345),\n' +
		'dot - a valid dot number (eg. dot:12345 or dot-12345),\n' +
		'name - a valid business name';

	@ViewChild('tabGroup') tabGroup;

	environment = environment;

	// CN-8312: Kanban layout - supports ?layout=v3 query param. Defaults to Collapsible.
	useLayoutV3: boolean = false;

	// CN-8312: V3 Ribbon Menu configuration
	// CN-8312: order — Project definition first, then Carrier (quality + contact
	// info), then Notes, then Tasks.
	ribbonMenuItems = [
		{ id: 'project', label: 'Project', icon: 'description' },
		// The 'quality' tray now also surfaces the selected carrier's contact info
		// + log-a-call actions, so the ribbon item reads "Carrier" with a
		// contact-oriented icon rather than the old quality-only "verified" badge.
		// The id stays 'quality' to avoid churning every activeRibbonItem check;
		// only the user-facing label / icon / title / position change.
		{ id: 'quality', label: 'Carrier', icon: 'contact_phone' },
		{ id: 'notes', label: 'Notes', icon: 'note' },
		{ id: 'tasks', label: 'Tasks', icon: 'check_circle' },
	];
	activeRibbonItem: string | null = null;
	isRibbonTrayOpen: boolean = false;
	ribbonTrayTitle: string = '';

	searchTruckForm = null;
	isUpdatingProject: boolean = false;
	lanePricing: any = null;
	carrierIdsToFetchNotes: string[] = [];
	isCarrierRatesEnabled: boolean = false;

	// vars
	selectedCarrierIds: Array<string> = [];
	carrierFiltersModel = {
		originDeadhead: null,
		destinationDeadhead: null,
		powerUnits: 0,
		minLoadsPerWeek: 0,
		ratesOnly: false,
		carriersSearchText: '',
		carrierHQ: '',
		carrierSelected: 'All Carriers',
		capacitySearchSort: RANGE_FILTERS.SORT.MATCH,
		qualityFilter: '',
	};
	carrierHQOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIER_HQ;
	carriersFilterOptions: string[] = CAPACITY_SEARCH_FILTER.CARRIERS;
	qualityFilterOptions = QUALITY_FILTER_OPTIONS;
	usersList: Array<Owner> = [];
	allUsersList: Array<Owner> = [];
	RANGE_FILTERS = RANGE_FILTERS;
	CARGOCHIEF_KEYS = CARGOCHIEF_KEYS;
	pageContentAfterViewInit: boolean = false;
	openedQualityObject;
	isCarrierVettingIntegrationEnabled!: boolean;

	// variable for component state
	greenScreensEnabled = false;
	sonarEnabled = false;
	onRecommendedTab: boolean = false;
	onAllocationsTab: boolean = false;
	onEngagedTab: boolean = false;
	onProcuredTab: boolean = false;
	procuredTabCarriersList: ProjectCarrierMapDTO[] = [];
	engagedTabCarriersList: ProjectCarrierMapDTO[] = [];

	private viewInitialized = new BehaviorSubject<boolean>(false);
	isAfterViewInitCompleted$ = this.viewInitialized.asObservable();
	isWaterfallOrDedicatedLaneProject: boolean = false;

	// Track selected carrier ID reactively to avoid NG0100 errors
	private selectedCarrierIdSubject = new BehaviorSubject<string | null>(null);

	rehydratedProjectId: string = null;
	restoredActiveTab: boolean = false;
	currentProjectHasSavedFilters: boolean = false;
	filtersReapplyBound: boolean = false;
	defaultOriginDeadhead: number = null;
	defaultDestinationDeadhead: number = null;
	filterIndicator: string = '';

	constructor(
		private urlService: UrlService,
		private activeRoute: ActivatedRoute,
		private restService: RestService,
		public utilService: UtilService,
		private segmentWrapper: SegmentWrapperService,
		public cargochief: Cargochief,
		private firebaseService: FirebaseService,
		private sharedService: SharedService,
		public projectHelperService: ProjectHelperService,
		public accountSettings: AccountSettingsService,
		public carrierSearchHelper: CarrierSearchHelperService,
		private projectDetailsService: ProjectDetailsService,
		private pricingFeedbackService: PricingFeedbackService,
		private notesService: NotesService,
		public productsService: ProductsService,
		private capacitySearchFilterService: CapacitySearchFilterService,
		public readonly projectDetailsStore: ProjectDetailsStore,
		public readonly recommendedCarriersStore: RecommendedCarriersStore,
		private store: Store,
		private actions$: Actions<any>,
		public userSettings: UserSettingsService,
		private dialog: MatDialog,
		public readonly projectDetailsEffects: ProjectDetailsEffects,
		public readonly recommendedCarriersEffects: RecommendedCarriersEffects,
		private router: Router,
		private accessCacheService: AccessCacheService,
		public integrationService: IntegrationService,
		public bookingAssistantService: BookingAssistantService,
		public baConfigService: BaConfigService,
		private projectGroupService: ProjectGroupService
	) {
		super();
	}

	async ngOnInit() {
		if (!this.productsService.PROJECT_CARRIERS) {
			this.utilService.navigateToDefaultViewForUser();
		} else {
			this.utilService.checkIfUserRoleAdminOrOwnerOnly();

			this.usersList = ACTIVE_USERS(this.accessCacheService.getAccountUsers());
			this.allUsersList = ALL_ACCOUNT_USERS(this.accessCacheService.getAccountUsers());
			this.store.dispatch(PROJECT_DETAILS.SET.USERS_LIST({ usersList: this.usersList }));

			this.activeRoute.queryParams.subscribe((params) => {
				if (IS_NULL_OR_UNDEFINED(params.fullProfile) && this.isLaneDetailsProfileView) {
					this.isLaneDetailsProfileView = false;
				}

				// CN-8312: Resolve procurement layout version
				// Precedence: ?layout=v3 query param > user preference > Collapsible default.
				// User preference only applied when PROCUREMENT_VERSIONS account setting is enabled
				this.useLayoutV3 =
					params.layout === 'v3' ||
					(this.accountSettings.PROCUREMENT_VERSIONS &&
						this.userSettings.PROCUREMENT_VERSION_PREFERENCE ===
							PROCUREMENT_VERSION.KANBAN);
			});

			this.activeRoute.params.subscribe((params: any) => {
				this.store.dispatch(PROJECT_DETAILS.PROJECT.SET_ID({ projectId: params['id'] }));
				this.projectId = params['id'];
				this.rehydratedProjectId = null;
				this.restoredActiveTab = false;
				this.currentProjectHasSavedFilters = false;
				if (!this.utilService.isNullOrUndefined(this.projectId)) {
					setTimeout(() => {
						this.projectDTO = null;
						this.projectCarrierMapList = [];
						// this.PAGE = 0;
						// CN-8312: Only set tab index if tabGroup exists (not in V3 layout)
						if (this.tabGroup) {
							this.tabGroup.selectedIndex = environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS ? 2 : 1;
						}
						this.searchTruckForm = null;
						this.store.dispatch(PROJECT_CARRIER_MAP.GET_ALL({}));
						this.store.dispatch(PROJECT_DETAILS.PROJECT.GET({}));
					});
				}
			});
			this.subscribeToFirebaseNotification();

			this.sharedService.getCarrierSearchEvent().subscribe((data: any) => {
				if (
					!this.utilService.isNullOrUndefined(data) &&
					!this.utilService.isNullOrUndefined(this.projectCarrierMapList)
				) {
					switch (data.type) {
						case 'note':
							this.projectCarrierMapList.map((projectCarrierMap: ProjectCarrierMapDTO) => {
								if (projectCarrierMap.carrier.id == data.value.capacitySearch.carrierId) {
									projectCarrierMap.notesCount = data.value.notesListComponent.totalNotes;
								}
							});
							break;
						case 'project':
							if (this.projectId == data.value.projectId) {
								setTimeout(() => {
									this.utilService.showSnackbar(
										'Project updated. Reloading this page.',
										SNACKBAR.WARNING,
										SNACKBAR.ACTION
									);
								}, 2500);
								setTimeout(() => {
									window.location.reload();
								}, 5000);
							}
							break;
					}
				}
			});
			const activeIntegrations = this.cargochief.getActiveIntegrations();
			this.greenScreensEnabled =
				IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
				activeIntegrations.includes(INTEGRATION_TYPE.GREEN_SCREENS);
			this.sonarEnabled =
				IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
				activeIntegrations.includes(INTEGRATION_TYPE.SONAR);
		}
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
		this.CARRIER_QUALITY_ENABLED = this.accountSettings.CARRIER_QUALITY;

		this.projectDetailsStore.loadingProjectCarrierMaps$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged())
			.subscribe((value) => {
				if (!value) {
					this.onTabChange();
				}
			});

		// CN-8312 V3: clear the ribbon Notes/Tasks badges the instant focus
		// changes so the previous carrier's counts don't linger while the new
		// carrier's note-list / tasks-list API call is in flight. The child
		// components re-emit the actual totals via (noteCountUpdated) /
		// (totalNumberOfTasks) once their fetch returns. Covers every focus
		// path — body click, gutter checkbox, project-group click, collapse —
		// because they all funnel through selectedCarrierIdSubject.next().
		this.selectedCarrierIdSubject
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged())
			.subscribe((carrierId) => {
				this.totalNumberOfNotes = null;
				this.totalNumberOfTasks = null;
				// CN-8312: load the focused carrier's full contact list for the
				// Carrier tray Contacts section (same source other carrier views use).
				this.loadTrayContacts(carrierId);
			});
	}

	ngAfterViewInit() {
		super.setDefaultPageWidth(
			'project details',
			MIN_WIDTH_CONTAINER_CLASS.PAGE_WIDTH_DEFAULT_CLASS,
			MIN_PAGE_CONTAINER_WIDTH.DEFAULT_PAGE_WIDTH
		);
		this.pageContentAfterViewInit = true;
		this.subscribeToStoreActions();
		this.initializeDeadheadFilters();
		this.setTabGroupsIndex();

		this.projectDetailsStore.projectDTO$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged())
			.subscribe((projectDTO) => {
				this.projectDTO = projectDTO;
				this.isWaterfallOrDedicatedLaneProject = IS_WORKFLOW_PROJECT_TYPE(this.projectDTO?.type);
				this.customerOnly =
					IS_NOT_NULL_OR_UNDEFINED(this.projectDTO) &&
					IS_EMPTY(this.projectDTO.originCity) &&
					IS_EMPTY(this.projectDTO.originState) &&
					IS_EMPTY(this.projectDTO.destCity) &&
					IS_EMPTY(this.projectDTO.destState) &&
					IS_EMPTY(this.projectDTO.equipmentType) &&
					IS_NOT_NULL_OR_UNDEFINED(this.projectDTO.customerDTO);

				// Load carrier allocations for workflow projects
				if (this.isWaterfallOrDedicatedLaneProject && this.projectId) {
					this.store.dispatch(PROJECT_DETAILS.ALLOCATIONS.LOAD({ projectId: this.projectId }));
				}

				this.rehydrateProjectFilters();
			});
		Promise.resolve().then(() => {
			this.viewInitialized.next(true);
		});
	}

	ngOnChanges() {
		this.isCarrierRatesEnabled =
			environment.CARRIER_RATES &&
			this.productsService.CARRIER_RATES &&
			this.accountSettings.CARRIER_RATES;
	}

	subscribeToFirebaseNotification() {
		this.firebaseService.requestPermission();
		this.firebaseService
			.getNotificationData()
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe((message: any) => {
				if (
					IS_NOT_NULL_OR_UNDEFINED(message) &&
					IS_NOT_NULL_OR_UNDEFINED(this.projectDTO) &&
					this.projectDTO.id == message['notification.projectId']
				) {
					if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.ProjectRateReceivedEmailCommand) {
						if (this.projectCarrierMapList?.length > 0) {
							this.store.dispatch(
								PROJECT_CARRIER_MAP.NOTIFICATION_UPDATES.RATE_RECEIVED_EMAIL({
									projectCarrierMapId: message['notification.projectCarrierMapId'],
									desiredPrice: +message['notification.desiredPrice'],
									carrierRespondedAt: message['notification.carrierRespondedAt'],
									carrierNotAvailable: message['notification.carrierNotAvailable'],
								})
							);
						}
					}
					if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.ProjectBestRateUpdatedCommand) {
						this.store.dispatch(
							PROJECT_DETAILS.NOTIFICATION_UPDATES.BEST_RATE({
								bestRate: +message['notification.bestRate'],
							})
						);
					}
					if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CalculateProbabilityCommand) {
						this.store.dispatch(
							PROJECT_DETAILS.NOTIFICATION_UPDATES.PROBABILITY({
								probability: +message['notification.probability'],
							})
						);
					}
					if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CarrierOpenedEmail) {
						if (this.projectCarrierMapList?.length > 0) {
							this.store.dispatch(
								PROJECT_CARRIER_MAP.NOTIFICATION_UPDATES.CARRIER_OPENED_EMAIL({
									projectCarrierMapId: message['notification.projectCarrierMapId'],
									carrierLastOpenedEmailAt: new Date(),
								})
							);
						}
					}
					if (message[NOTIFICATION_NAME] == NOTIFICATION_TYPES.CarrierNotAvailableRFPCommand) {
						if (this.projectCarrierMapList?.length > 0) {
							this.store.dispatch(
								PROJECT_CARRIER_MAP.NOTIFICATION_UPDATES.CARRIER_NOT_AVAILABLE({
									projectCarrierMapId: message['notification.projectCarrierMapId'],
									carrierNotAvailable: true,
									carrierRespondedAt: new Date(),
								})
							);
						}
					}
				}
			});
	}

	openFullProfile(projectCarrierMap: any, event: MouseEvent) {
		if (!this.utilService.isNullOrUndefined(event) && event.shiftKey) {
			this.panelClicked({
				projectCarrierMap,
				event,
				cardIndex: -1,
				wasExpanded: false,
				shiftKey: true,
			});
			return;
		}
		const carrier: any = Object.assign({}, projectCarrierMap.carrier);
		this.carrierLaneData = null;
		this.contactList = null;
		this.recentFeedbackList = null;
		this.isLaneDetailsProfileView = true;
		this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.user_viewed_full_profile, carrier);
		this.getCarrierContacts(carrier);
		this.getRecentFeedbackList(carrier.id);
		this.openedQualityObject =
			this.tabGroup.selectedIndex == 0
				? this.getRecommendedCarrierOpened()
				: this.getCarrierQualityObject(projectCarrierMap.carrier);
		this.openedQualityObject['firmDot'] = projectCarrierMap.carrier.dot;
		this.openedQualityObject['active'] = projectCarrierMap.carrier.active;
	}

	getCarrierContacts(carrier: any) {
		const contactsUrl = this.urlService.contactsUrl(carrier.id);
		this.restService.GET(contactsUrl).subscribe(
			(result) => {
				this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.contact_requested, result);
				this.contactList = result['data'];
				const accountCarrierMap = carrier?.accountCarrierMaps?.find(
					(acm) => acm.accountId == this.cargochief.ACCOUNT_ID
				);
				this.carrierLaneData = {
					lane: {
						businessName: carrier.businessName,
						customerCarrier:
							this.tabGroup.selectedIndex == 0
								? this.openedQualityObject.customerCarrier
								: IS_NOT_NULL_OR_UNDEFINED(accountCarrierMap),
						firmMc: carrier.mc,
						firmDot: carrier.dot,
						powerUnits: carrier.powerUnits,
						drivers: carrier.drivers,
						carrierId: carrier.id,
						carrierHQ: HQ_LOCATION_PARSER(carrier.city, carrier.state),
						hazmat: carrier.hazmat,
						hasTeams: carrier.hasTeams,
						hasTeamsUpdatedOn: carrier.hasTeamsUpdatedOn,
						vettingOverallDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOverallDisplay
							: carrier?.vettingOverallDisplay,
						vettingAuthorityDisplay: accountCarrierMap
							? accountCarrierMap?.vettingAuthorityDisplay
							: carrier?.vettingAuthorityDisplay,
						vettingInsuranceDisplay: accountCarrierMap
							? accountCarrierMap?.vettingInsuranceDisplay
							: carrier?.vettingInsuranceDisplay,
						vettingOperationsDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOperationsDisplay
							: carrier?.vettingOperationsDisplay,
						vettingOtherDisplay: accountCarrierMap
							? accountCarrierMap?.vettingOtherDisplay
							: carrier?.vettingOtherDisplay,
						vettingSafetyDisplay: accountCarrierMap
							? accountCarrierMap?.vettingSafetyDisplay
							: carrier?.vettingSafetyDisplay,
						lastVettingTime: accountCarrierMap
							? accountCarrierMap?.lastVettingTime
							: carrier.lastVettingTime,
						trailers: carrier.trailers,
						phone: carrier.phone,
						cellPhone: carrier.cellPhone,
						businessEmailAddress: carrier.businessEmailAddress,
						representative1: carrier.representative1,
					},
					contactList: this.contactList,
				};
			},
			(error) => {
				this.utilService.showSnackbar(
					'Cannot fetch contact list.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.contactList = [];
			}
		);
	}

	getRecentFeedbackList(id: string) {
		const url = this.urlService.getCarrierFeedback(id, {
			pageSize: CARRIER_FEEDBACK_SETTINGS.PAGE_SIZE,
		});
		this.restService.GET(url).subscribe((response) => {
			this.recentFeedbackList = response['data'];
		});
	}

	fireSegmentEvent(projectId: string, carrierId: string, cIndex: number) {
		const payload = {
			carrier: {
				businessName: this.projectCarrierMapList[cIndex].carrier.businessName,
				carrierId: carrierId,
			},
			projectId: projectId,
			page: 'Project Details',
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_added_carrier_to_projects,
			payload
		);
	}

	updateProject(isOwnerAssigned: boolean, updateMsg: string, projectDTO: ProjectDTO) {
		const { requireTeamsEnabled, requireTeamsDisabled } =
			this.projectDetailsService.isRequireTeamsUpdated({
				oldProjectDTO: this.projectDTO,
				newProjectDTO: projectDTO,
			});
		const oldProjectType = this.projectDTO?.type;
		// Capture before the PUT: once the type flips to Procurement the store stops
		// building groups, so reading them afterwards would return an empty list.
		const groupIdsBeforeUpdate = this.projectGroupsSnapshot();
		const url = this.urlService.addProject() + `${isOwnerAssigned ? '?&isOwnerUpdated=true' : ''}`;
		this.isUpdatingProject = true;
		this.restService.PUT(url, projectDTO).subscribe(
			async (result: any) => {
				this.projectDTO = this.projectHelperService.convertProjectCentsToDollars(result.data);
				this.searchTruckForm = this.projectDetailsService.getSearchTruckForm(this.projectDTO);
				this.store.dispatch(
					PROJECT_DETAILS.PROJECT.SET_CAPACITY_SEARCH_FORM({
						searchTruckForm: this.searchTruckForm,
					})
				);
				this.store.dispatch(PROJECT_DETAILS.PROJECT.SUCCESS({ projectDTO: this.projectDTO }));
				this.utilService.showSnackbar(updateMsg, SNACKBAR.SUCCESS, SNACKBAR.ACTION);
				// Handle project type transitions involving groups
				const changedToProcurement =
					oldProjectType !== PROJECT_TYPES.PROCUREMENT.value &&
					this.projectDTO.type === PROJECT_TYPES.PROCUREMENT.value;
				const changedToWorkflow =
					oldProjectType === PROJECT_TYPES.PROCUREMENT.value &&
					this.projectDTO.type !== PROJECT_TYPES.PROCUREMENT.value;
				if (changedToProcurement) {
					// Delete all groups since Procurement does not support project groups
					if (groupIdsBeforeUpdate.length) {
						this.store.dispatch(PROJECT_GROUPS.DELETE({ ids: groupIdsBeforeUpdate }));
					}
				} else if (changedToWorkflow) {
					// Create groups for existing procured carriers when switching to Workflow
					const state: ProjectDetailsState = await firstValueFrom(
						this.store.select((storeState) => storeState[projectDetailsPageStateKey]).pipe(take(1))
					);
					if (!state.projectGroups?.length && state.procuredCarriersList?.length) {
						this.projectDetailsEffects.moveCarriersToGroupsWhenCarriersProcured(
							state,
							state.procuredCarriersList
						);
					}
				}
				this.isUpdatingProject = false;
				if (requireTeamsEnabled || requireTeamsDisabled) {
					if (requireTeamsDisabled) {
						this.recommendedCarriersComponent?.initiateSearch();
						return;
					}
					const removeProcuredCarriersWithoutTeams =
						await this.projectDetailsService.showProcuredCarriersRemovalConfirmation();
					if (IS_NOT_NULL_OR_UNDEFINED(removeProcuredCarriersWithoutTeams)) {
						this.selectedProjectCarrierMapIDs =
							this.projectDetailsService.getProjectCarrierMapIdsWithoutTeams(
								this.projectCarrierMapList
							);
						if (this.selectedProjectCarrierMapIDs.length > 0) {
							this.removeProcuredCarriers();
						} else {
							this.recommendedCarriersComponent?.initiateSearch();
						}
					} else {
						this.recommendedCarriersComponent?.initiateSearch();
					}
				}
			},
			(error) => {
				this.store.dispatch(
					ERROR_HANDLING.HANDLE_PROJECT_UPDATE_ERROR({
						error,
						forAdd: false,
						defaultErrorMessage: 'Unable to update project now.',
					})
				);
				this.isUpdatingProject = false;
			}
		);
	}

	// Synchronous read of the current group ids, for use before an update flips the project type.
	projectGroupsSnapshot(): string[] {
		let ids: string[] = [];
		this.projectDetailsStore.projectGroups$
			.pipe(take(1))
			.subscribe((groups) => (ids = (groups || []).map((group) => group.id)));
		return ids;
	}

	rfpCompleted(data) {
		if (IS_NOT_NULL_OR_UNDEFINED(data) && data) {
			this.projectDTO.rfpRequestedDate = new Date();
		}
	}

	// CN-8778: project_carrier_map ids for the current tab's (filtered) list, so Check Capacity
	// scopes its send to exactly the carriers currently shown on the tab.
	projectCarrierMapIds(list: ProjectCarrierMapDTO[]): string[] {
		return (list || []).map((pcm) => pcm.id);
	}

	panelClicked(payload: {
		projectCarrierMap: ProjectCarrierMapDTO;
		event: MouseEvent;
		cardIndex: number;
		wasExpanded: boolean;
		shiftKey: boolean;
	}) {
		const { projectCarrierMap, event, wasExpanded, shiftKey } = payload;

		document.getSelection().removeAllRanges();

		// CN-8312 V2: the bulk-select gutter checkbox owns selection. Card body
		// clicks drive expansion + focus the right panel (Quality / Notes / Tasks) on
		// the clicked carrier WITHOUT mutating the selection arrays — the gutter
		// checkbox stays in whatever state the user left it. V3 (Kanban) and Workflow
		// projects render no gutter, so they keep click-to-select + shift-multi-select.
		if (!this.useLayoutV3 && !this.isWaterfallOrDedicatedLaneProject) {
			if (wasExpanded) {
				// Collapsing: drop focus. Recompute carrierIdsToFetchNotes from the
				// selection arrays so the right panel falls back to whatever is
				// checked via the gutter (or empties out when nothing is checked).
				this.selectedCarrierIdSubject.next(
					this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
				);
				this.populateCarrierIdsToFetchNotes();
			} else {
				// Expanding: focus this carrier in the right panel. Setting
				// carrierIdsToFetchNotes directly is what drives the Quality, Notes,
				// and Tasks panels; selectedProjectCarrierMapIDs / selectedCarrierIds
				// stay untouched so the gutter and Action menu predicates still
				// reflect the user's checkbox state.
				this.selectedCarrierIdSubject.next(projectCarrierMap.carrier.id);
				this.carrierIdsToFetchNotes = [projectCarrierMap.carrier.id];
				this.populateVisibleCarrierIds();
			}
			return;
		}

		if (!shiftKey) {
			// V1 non-shift click => single-select mode
			if (wasExpanded) {
				// clicking the already-expanded card => collapse + deselect
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
				this.selectedCarrierIdSubject.next(null);
			} else {
				// clicking any other card => select only that one
				this.selectedProjectCarrierMapIDs = [projectCarrierMap.id];
				this.selectedCarrierIds = [projectCarrierMap.carrier.id];
				this.selectedCarrierIdSubject.next(projectCarrierMap.carrier.id);
				// CN-8312 V3: in V3 all three columns are visible simultaneously,
				// so clear any focused Recommended card (pannel-wrapper's internal
				// `step`) when the user picks an Engaged / Procured carrier — only
				// one card should appear selected at a time across columns. No-op
				// in V1/V2 where Recommended sits behind a tab.
				if (this.useLayoutV3) {
					this.recommendedCarriersComponent?.pannelWrapperComponent?.closeAllPannels();
				}
			}
		} else {
			// V1 shift click => multi-select toggle only (no expand)
			const existingIndex = this.selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id);
			if (existingIndex > -1) {
				this.selectedProjectCarrierMapIDs.splice(existingIndex, 1);
				this.selectedCarrierIds = this.selectedCarrierIds.filter(
					(carrierId) => carrierId !== projectCarrierMap.carrier.id
				);
			} else {
				this.selectedProjectCarrierMapIDs.push(projectCarrierMap.id);
				this.selectedCarrierIds.push(projectCarrierMap.carrier.id);
			}

			// Multi-select: only emit carrier ID if exactly one is selected
			this.selectedCarrierIdSubject.next(
				this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
			);
		}

		this.populateCarrierIdsToFetchNotes();
	}

	/**
	 * CN-8312 V2: handler for the leading bulk-select gutter checkbox.
	 * Toggles the carrier in/out of the same arrays the Actions menu reads, so menu
	 * predicates work unchanged. Independent of expansion state.
	 */
	onBulkSelectToggle(projectCarrierMap: ProjectCarrierMapDTO) {
		const existingIndex = this.selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id);
		if (existingIndex > -1) {
			this.selectedProjectCarrierMapIDs.splice(existingIndex, 1);
			this.selectedCarrierIds = this.selectedCarrierIds.filter(
				(carrierId) => carrierId !== projectCarrierMap.carrier.id
			);
		} else {
			this.selectedProjectCarrierMapIDs.push(projectCarrierMap.id);
			this.selectedCarrierIds.push(projectCarrierMap.carrier.id);
		}
		this.selectedProjectCarrierMapIDs = [...this.selectedProjectCarrierMapIDs];
		this.selectedCarrierIds = [...this.selectedCarrierIds];
		this.selectedCarrierIdSubject.next(
			this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
		);
		this.populateCarrierIdsToFetchNotes();
	}

	/**
	 * CN-8312 V2: handler for the Recommended-side bulk-select gutter checkbox.
	 * The Recommended list operates on TruckSearchTable rows (no projectCarrierMap),
	 * so we can only sync selectedCarrierIds. selectedProjectCarrierMapIDs stays empty
	 * because there is no project-carrier-map for an unmatched recommended carrier.
	 */
	onRecommendedBulkSelectToggle(search: any) {
		const carrierId = search?.carrierId;
		if (!carrierId) return;
		const idx = this.selectedCarrierIds.indexOf(carrierId);
		if (idx > -1) {
			this.selectedCarrierIds.splice(idx, 1);
		} else {
			this.selectedCarrierIds.push(carrierId);
		}
		this.selectedCarrierIds = [...this.selectedCarrierIds];
		this.selectedCarrierIdSubject.next(
			this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
		);
		this.populateCarrierIdsToFetchNotes();
	}

	/**
	 * CN-8312 V2: Recommended-tab body click. Focus the right panel (Quality /
	 * Notes / Tasks) on the clicked carrier without mutating the bulk-select
	 * gutter. On collapse, fall back to whatever the gutter currently has
	 * checked. Mirrors the in-component logic for Engaged/Procured in
	 * panelClicked.
	 */
	onRecommendedPanelFocused(search: any) {
		const carrierId = search?.carrierId;
		if (carrierId) {
			// CN-8312 V3: clear any active Engaged / Procured selection when a
			// Recommended card is focused. V3 shows all three columns
			// simultaneously, so without this the user can end up with one card
			// highlighted in two columns at once and stale selection state
			// driving the Actions menu. Gated on useLayoutV3 because V2 keeps
			// Recommended in a tab and relies on the bulk-select gutter contract
			// where body clicks NEVER mutate selection arrays.
			if (this.useLayoutV3) {
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
			}
			this.selectedCarrierIdSubject.next(carrierId);
			this.carrierIdsToFetchNotes = [carrierId];
			this.populateVisibleCarrierIds();
		} else {
			this.selectedCarrierIdSubject.next(
				this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
			);
			this.populateCarrierIdsToFetchNotes();
		}
	}

	/**
	 * CN-8312 V2: tab-strip select-all behavior. If everything in the active tab is
	 * already selected, clear; otherwise select every loaded carrier in that tab.
	 */
	toggleSelectAllOnCurrentTab() {
		if (this.isAllSelectedOnCurrentTab()) {
			this.selectedProjectCarrierMapIDs = [];
			this.selectedCarrierIds = [];
			this.selectedCarrierIdSubject.next(null);
			this.populateCarrierIdsToFetchNotes();
			return;
		}
		const list = this.getCurrentTabCarrierList();
		const tabIdx = this.tabGroup?.selectedIndex;
		if (tabIdx === 0) {
			// Recommended tab: list items are TruckSearchTable rows
			this.selectedProjectCarrierMapIDs = [];
			this.selectedCarrierIds = list.map((row: any) => row.carrierId).filter(Boolean);
		} else {
			// Engaged / Procured: project-carrier-map rows
			this.selectedProjectCarrierMapIDs = list.map((m: any) => m.id);
			this.selectedCarrierIds = list.map((m: any) => m.carrier?.id).filter(Boolean);
		}
		this.selectedCarrierIdSubject.next(
			this.selectedCarrierIds.length === 1 ? this.selectedCarrierIds[0] : null
		);
		this.populateCarrierIdsToFetchNotes();
	}

	/** CN-8312 V2: true when every loaded carrier in the current tab is selected. */
	isAllSelectedOnCurrentTab(): boolean {
		const list = this.getCurrentTabCarrierList();
		if (!list?.length) return false;
		const tabIdx = this.tabGroup?.selectedIndex;
		if (tabIdx === 0) {
			return list.every((row: any) => this.selectedCarrierIds.includes(row.carrierId));
		}
		return list.every((m: any) => this.selectedProjectCarrierMapIDs.includes(m.id));
	}

	/** CN-8312 V2: true when some-but-not-all carriers in the current tab are selected. */
	isSomeSelectedOnCurrentTab(): boolean {
		const list = this.getCurrentTabCarrierList();
		if (!list?.length) return false;
		const tabIdx = this.tabGroup?.selectedIndex;
		const matchCount =
			tabIdx === 0
				? list.filter((row: any) => this.selectedCarrierIds.includes(row.carrierId)).length
				: list.filter((m: any) => this.selectedProjectCarrierMapIDs.includes(m.id)).length;
		return matchCount > 0 && matchCount < list.length;
	}

	/**
	 * CN-8312 V2: returns the loaded carrier list for the active tab. Recommended uses
	 * TruckSearchTable rows; Engaged / Procured use ProjectCarrierMapDTO rows.
	 */
	private getCurrentTabCarrierList(): any[] {
		const tabIdx = this.tabGroup?.selectedIndex;
		if (tabIdx === 0) {
			// Recommended list lives on the inner pannel-wrapper, not the recommended-carriers
			// component itself. Reach through to it.
			return (
				this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults ||
				[]
			);
		}
		// Engaged tab when the engaged tab is enabled, otherwise Procured at index 1
		const engagedEnabled = environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS;
		if (engagedEnabled && tabIdx === 1) {
			return (
				(this.engagedCarriersComponent &&
					this.engagedCarriersComponent.projectCarrierMapList) ||
				[]
			);
		}
		// Procured (or Procured at index 1 when engaged tab is disabled)
		return (
			(this.procuredCarriersComponent &&
				this.procuredCarriersComponent.projectCarrierMapList) ||
			[]
		);
	}

	/** CN-8312 V2: true when the user is on a tab that doesn't list carriers (FILTER). */
	isCarrierTabActive(): boolean {
		const tabIdx = this.tabGroup?.selectedIndex;
		if (tabIdx == null) return false;
		const engagedEnabled = environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS;
		const lastCarrierTabIdx = engagedEnabled ? 2 : 1;
		return tabIdx <= lastCarrierTabIdx;
	}

	/**
	 * CN-8312 V2: toggle the recommended-tab Actions menu's "▼ scroll for more"
	 * indicator based on whether the panel content actually overflows. Material
	 * legacy mat-menu only captures the static `class` attribute at compile time,
	 * so runtime overflow detection has to set the class on the live overlay
	 * element. Runs after a microtask so the panel is in the DOM with its final
	 * content height when we measure.
	 */
	updateRecommendedTabActionsPanelClass() {
		setTimeout(() => {
			document.querySelectorAll('.cc_menu_container.mat-menu-panel').forEach((panel) => {
				const content = panel.querySelector('.mat-menu-content') as HTMLElement | null;
				const overflows = !!content && content.scrollHeight > content.clientHeight;
				panel.classList.toggle('cc_menu_no_scroll_indicator', !overflows);
			});
		});
	}

	/**
	 * Handler for panel clicks on the Allocations tab.
	 * Similar to panelClicked but uses selectedAllocatedCarrierMapIDs.
	 */
	onAllocatedCarrierPanelClicked(payload: {
		projectCarrierMap: ProjectCarrierMapDTO;
		event: MouseEvent;
		cardIndex: number;
		wasExpanded: boolean;
		shiftKey: boolean;
	}) {
		const { projectCarrierMap, event, wasExpanded, shiftKey } = payload;

		document.getSelection().removeAllRanges();

		if (!shiftKey) {
			// non-shift click => single-select mode
			if (wasExpanded) {
				// clicking the already-expanded card => collapse + deselect
				this.selectedAllocatedCarrierMapIDs = [];
				this.selectedCarrierIdSubject.next(null);
			} else {
				// clicking any other card => select only that one
				this.selectedAllocatedCarrierMapIDs = [projectCarrierMap.id];
				this.selectedCarrierIdSubject.next(projectCarrierMap.carrier.id);
			}
		} else {
			// shift click => multi-select toggle only (no expand)
			const existingIndex = this.selectedAllocatedCarrierMapIDs.indexOf(projectCarrierMap.id);
			if (existingIndex > -1) {
				this.selectedAllocatedCarrierMapIDs.splice(existingIndex, 1);
			} else {
				this.selectedAllocatedCarrierMapIDs.push(projectCarrierMap.id);
			}

			// Multi-select: only emit carrier ID if exactly one is selected
			this.selectedCarrierIdSubject.next(
				this.selectedAllocatedCarrierMapIDs.length === 1 ? projectCarrierMap.carrier.id : null
			);
		}

		this.populateCarrierIdsToFetchNotes();
	}

	showPricingAndRecentTransactions(): boolean {
		return this.productsService.PRICING || this.productsService.RECENT_TRANSACTIONS;
	}

	populateSearchTruckForm() {
		this.searchTruckForm = this.projectDetailsService.getSearchTruckForm(this.projectDTO);
		const frequencyFilter = this.cargochief.getItem(CARGOCHIEF_KEYS.FREQUENCY_FILTER);
		if (IS_NOT_NULL_OR_UNDEFINED(frequencyFilter)) {
			const { minLoadsPerWeek } = JSON.parse(frequencyFilter);
			this.searchTruckForm.minLoadsPerWeek = this.carrierFiltersModel.minLoadsPerWeek =
				minLoadsPerWeek;
		}
	}

	async lanePricingCompleted(lanePricing: any) {
		this.lanePricing = lanePricing;
		const feedbackCount = this.cargochief.getItem(CARGOCHIEF_KEYS.FEEDBACK_COUNT);
		if (
			!this.utilService.isNullOrUndefined(this.lanePricing) &&
			this.pricingFeedbackService.searchLimitExceeded()
		) {
			if (
				IS_NULL_OR_UNDEFINED(feedbackCount) ||
				(IS_NOT_EMPTY(feedbackCount) && Number(feedbackCount) <= environment.PRICING_FEEDBACK_LIMIT)
			) {
				await this.pricingFeedbackService.showFeedbackModal({
					lanePricing: this.lanePricing,
					searchTruckForm: this.searchTruckForm,
				});
				this.resetNoOfSearchesWithoutFeedbackCounter();
				this.pricingComponent.rateFeedbackProvided = true;
			} else if (
				this.pricingFeedbackService.searchLimitExceeded() &&
				IS_NOT_NULL_OR_UNDEFINED(feedbackCount) &&
				Number(feedbackCount) > environment.PRICING_FEEDBACK_LIMIT
			) {
				this.sharedService.sendfeedbackNotificationEvent(true);
			}
		}
	}

	resetNoOfSearchesWithoutFeedbackCounter() {
		this.pricingFeedbackService.setNoOfSearchesWithoutFeedbackCounter(0);
	}

	populateCarrierIdsToFetchNotes(): void {
		this.carrierIdsToFetchNotes = [];
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.selectedProjectCarrierMapIDs) &&
			this.selectedProjectCarrierMapIDs.length > 0
		) {
			this.projectCarrierMapList?.forEach((projectCarrierMap) => {
				if (
					IS_NOT_NULL_OR_UNDEFINED(
						this.selectedProjectCarrierMapIDs.find(
							(selectedProjectCarrierMapId) => selectedProjectCarrierMapId == projectCarrierMap.id
						)
					)
				) {
					this.carrierIdsToFetchNotes.push(projectCarrierMap.carrier.id);
				}
			});
		}
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedCarrierIds) && this.selectedCarrierIds.length > 0) {
			this.carrierIdsToFetchNotes = [...this.carrierIdsToFetchNotes, ...this.selectedCarrierIds];
		}
		this.populateVisibleCarrierIds();
	}

	// method called on tab change
	async onTabChange() {
		this.onRecommendedTab = this.isRecommendedTab();
		this.onAllocationsTab = this.isAllocationsTab();
		this.updateRecommendedTabActionsPanelClass();
		const loadingProjectCarrierMaps = await firstValueFrom(
			this.projectDetailsStore.loadingProjectCarrierMaps$
		);
		this.onEngagedTab = this.isEngagedTab({ loadingProjectCarrierMaps });
		this.onProcuredTab = this.isProcuredTab({ loadingProjectCarrierMaps });

		const projectGroups = await firstValueFrom(this.projectDetailsStore.projectGroups$);
		const procuredCarriersList = await firstValueFrom(
			this.projectDetailsStore.procuredCarriersList$
		);
		this.procuredTabCarriersList = this.getProcuredCarriersList({
			projectGroups,
			procuredCarriersList,
		});
		if (this.onRecommendedTab) {
			this.recommendedCarriersComponent.pannelWrapperComponent.calculateViewportSize();
		}
		if (this.onAllocationsTab) {
			this.allocatedCarriersComponent?.calculateViewportSize();
		}
		if (this.onEngagedTab) {
			this.engagedCarriersComponent?.calculateViewportSize();
		}
		if (this.onProcuredTab) {
			this.projectGroupsComponent?.procuredCarriersComponent?.calculateViewportSize();
			this.procuredCarriersComponent?.calculateViewportSize();
		}
		this.persistProjectFilters();
	}

	resetSelectedCarriers() {
		this.carrierIdsToFetchNotes = [];
		this.selectedProjectCarrierMapIDs = [];
		this.selectedAllocatedCarrierMapIDs = [];
		this.selectedCarrierIds = [];
		this.selectedCarrierIdSubject.next(null);
		this.projectHelperService.sendSelectedCarriersResetEvent();
		if (this.recommendedCarriersComponent) {
			this.recommendedCarriersComponent.capacitySearchResults = [
				...this.recommendedCarriersComponent.capacitySearchResults,
			];
		}
		if (this.procuredCarriersComponent) {
			this.procuredCarriersComponent.step = undefined;
			this.procuredCarriersComponent.projectCarrierMapList = [
				...this.procuredCarriersComponent.projectCarrierMapList,
			];
		}
		if (this.allocatedCarriersComponent) {
			this.allocatedCarriersComponent.step = undefined;
			this.allocatedCarriersComponent.projectCarrierMapList = [
				...this.allocatedCarriersComponent.projectCarrierMapList,
			];
		}
		if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length) {
			this.projectGroupsComponent.selectedProjectCarrierMapIds = [];
		}
	}

	populateVisibleCarrierIds() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.tabGroup)) {
			let visibleCarrierIds = [];
			if (this.tabGroup.selectedIndex == 0) {
				const recommendedCarriersComponent = this.recommendedCarriersComponent;
				if (
					IS_NOT_NULL_OR_UNDEFINED(recommendedCarriersComponent.capacitySearchResults) &&
					recommendedCarriersComponent.capacitySearchResults.length > 0
				) {
					visibleCarrierIds = recommendedCarriersComponent.capacitySearchResults
						.filter((capacitySearchResult) =>
							IS_NOT_NULL_OR_UNDEFINED(capacitySearchResult.carrierId)
						)
						.map((capacitySearchResult) => capacitySearchResult.carrierId);
				}
			} else {
				if (this.projectCarrierMapList?.length > 0) {
					visibleCarrierIds = this.projectCarrierMapList
						.filter((projectCarrierMap) => IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap?.carrier?.id))
						.map((projectCarrierMap) => projectCarrierMap.carrier.id);
				}
			}
			this.notesService.sendVisibleCarriersUpdatedEvent(visibleCarrierIds);
		}
	}

	downloadCapacitySearchResultsCsv(): void {
		this.store.dispatch(
			RECOMMENDED_CARRIERS.CAPACITY_SEARCH.DOWNLOAD_CSV({
				capacitySearchResults:
					this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults,
				searchFormData: this.recommendedCarriersComponent?.searchFormData,
			})
		);
	}

	getNoteType(): NoteType {
		return this.carrierIdsToFetchNotes.length === 1 ? NoteType.CARRIER : NoteType.PROJECT;
	}

	engageWithCarriers() {
		this.recommendedToEngage(this.selectedCarrierIds);
	}

	removeEngagedCarriers() {
		if (this.userSettings.HIDE_ENGAGE_CARRIER_DIALOG) {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.DELETE({
					projectCarrierMapIDs: this.selectedProjectCarrierMapIDs,
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.START({
					projectCarrierMapIDs: this.selectedProjectCarrierMapIDs,
					noteType: this.getNoteType(),
				})
			);
		}
	}

	moveEngagedToProcured() {
		this.store.dispatch(
			PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.CREATE({
				projectCarrierMapIds: this.selectedProjectCarrierMapIDs,
				// CN-8312 V2: route through the EngageCarriersDialog so the user
				// can capture who-they-talked-to + notes alongside the rate, and
				// so a feedback row is written to advance Last Contact.
				useEngageDialog: !this.isWaterfallOrDedicatedLaneProject,
			})
		);
	}

	// CN-8777: bulk-onboard the currently-selected Engaged carriers that are onboard-eligible
	// (out-of-network / not yet vetted). Reuses the child card's showOnboardCarrier() gate so the
	// selection is filtered exactly like the per-carrier Onboard link.
	bulkOnboardEngagedCarriers() {
		const list = this.engagedCarriersComponent?.projectCarrierMapList || [];
		const eligible = list
			.filter((pcm) => this.selectedProjectCarrierMapIDs.indexOf(pcm.id) > -1)
			.map((pcm) => pcm.carrier)
			.filter((carrier) => this.engagedCarriersComponent.showOnboardCarrier(carrier));

		if (!eligible.length) {
			this.utilService.showSnackbar(
				'None of the selected carriers are eligible to onboard (already in your network or vetted).',
				SNACKBAR.ERROR,
				SNACKBAR.ACTION
			);
			return;
		}

		const payload: any = this.utilService.getUserDataForSegmentEvent();
		payload.page = 'engaged_tab_bulk';
		this.integrationService.bulkOnboardCarriers(eligible, payload);
	}

	// CN-8777: only offer the bulk Onboard action when a vetting integration + invite link exist.
	get canBulkOnboardEngaged(): boolean {
		return (
			this.isCarrierVettingIntegrationEnabled &&
			this.integrationService.isIntegrationUrlAvailable()
		);
	}

	moveRecommendedToProcured() {
		this.store.dispatch(
			RECOMMENDED_CARRIERS.PROCURE_CARRIERS.CREATE({
				selectedCarrierIds: this.selectedCarrierIds,
				// CN-8312 V2: see moveEngagedToProcured for rationale.
				useEngageDialog: !this.isWaterfallOrDedicatedLaneProject,
			})
		);
	}

	selectAllCarriers() {
		if (this.onRecommendedTab) {
			const carrierIds =
				this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults?.map(
					(carrier) => carrier.carrierId
				) || [];
			const allSelected =
				carrierIds.length === this.selectedCarrierIds.length &&
				carrierIds.every((id) => this.selectedCarrierIds.includes(id));

			if (allSelected) {
				// Deselect all carriers
				this.selectedCarrierIds = [];
				if (this.recommendedCarriersComponent?.pannelWrapperComponent) {
					this.recommendedCarriersComponent.pannelWrapperComponent.selectedCarrierIds = [];
					this.recommendedCarriersComponent.pannelWrapperComponent.updateSelectedcarrierIds.emit(
						[]
					);
				}
			} else {
				// Select all carriers
				this.selectedCarrierIds = [...carrierIds];
				if (this.recommendedCarriersComponent?.pannelWrapperComponent) {
					this.recommendedCarriersComponent.pannelWrapperComponent.selectedCarrierIds = [
						...carrierIds,
					];
					this.recommendedCarriersComponent.pannelWrapperComponent.updateSelectedcarrierIds.emit(
						carrierIds
					);
				}
			}
		}
		this.populateCarrierIdsToFetchNotes();
	}

	showRemoveButtonOnProcuredTab(): boolean {
		return environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS
			? this.tabGroup?.selectedIndex == 2
			: this.tabGroup?.selectedIndex == 1;
	}

	showProcuredTabOptions(tabIndex: number): boolean {
		if (environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS) {
			return tabIndex == 2;
		}
		return tabIndex == 1;
	}

	createProjectGroup() {
		let projectCarrierMapIds = this.projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds
			.length
			? this.projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds
			: this.selectedProjectCarrierMapIDs;
		if (
			!projectCarrierMapIds.length &&
			this.projectGroupsComponent.createGroupFromUserGroupEnabled &&
			this.projectGroupsComponent.selectedProjectCarrierMapIds.length
		) {
			projectCarrierMapIds = [...this.projectGroupsComponent.selectedProjectCarrierMapIds];
		}
		if (projectCarrierMapIds.length) {
			this.store.dispatch(
				PROJECT_GROUPS.OPEN_DIALOG({
					projectCarrierMapIds,
					projectId: this.projectId,
				})
			);
		}
	}

	moveProjectGroups(direction: string) {
		this.store.dispatch(
			PROJECT_GROUPS.MOVE_GROUPS({
				groupIds: this.projectGroupsComponent.selectedProjectGroupIds,
				direction,
			})
		);
	}

	removeFormGroup() {
		this.store.dispatch(
			PROJECT_GROUPS.DELETE_CARRIER({
				projectCarrierMapIds: this.projectGroupsComponent.selectedProjectCarrierMapIds,
			})
		);
	}

	async deleteGroups() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				// determine if carriers in groups deleted can be moved to lower priority group
				const deletedGroupsList: ProjectGroup[] = state.projectGroups
					.filter(
						(group) => this.projectGroupsComponent.selectedProjectGroupIds.indexOf(group.id) !== -1
					)
					.sort((a, b) => (a.delayByMinutes > b.delayByMinutes ? 1 : -1));
				const highestPriorityInDeletedGroups =
					deletedGroupsList[deletedGroupsList.length - 1].delayByMinutes;
				const lowerPriorityGroups = state.projectGroups.filter(
					(group) => !group.systemGroup && group.delayByMinutes > highestPriorityInDeletedGroups
				);
				let deleteProjectGroupRequest = {
					ids: this.projectGroupsComponent.selectedProjectGroupIds,
					moveToGroupId: null,
				};
				if (lowerPriorityGroups.length) {
					const moveToResponse = await this.dialog
						.open(AddToGroupComponent, {
							width: '500px',
							panelClass: 'cargo_chief_dialog_container',
							data: {
								dialogTitle: 'Move to Group',
								projectGroups: lowerPriorityGroups,
								closeButtonText: 'Cancel',
								submitButtonText: 'Move to Group',
							},
						})
						.afterClosed()
						.toPromise();
					if (moveToResponse?.projectGroupId) {
						deleteProjectGroupRequest.moveToGroupId = moveToResponse.projectGroupId;
					} else {
						return;
					}
				}
				this.store.dispatch(PROJECT_GROUPS.DELETE(deleteProjectGroupRequest));
			});
	}

	removeProcuredCarriers() {
		this.store.dispatch(
			PROJECT_CARRIER_MAP.PROCURED.DELETE({
				projectCarrierMapIDs: this.selectedProjectCarrierMapIDs.concat(
					this.projectGroupsComponent.selectedProjectCarrierMapIds
				),
				noteType: this.getNoteType(),
			})
		);
	}

	subscribeToStoreActions() {
		this.actions$
			.pipe(
				takeUntil(this.isDestroyed$),
				ofType(
					PROJECT_GROUPS.CREATE_SUCCESS,
					PROJECT_GROUPS.DELETE_SUCCESS,
					PROJECT_GROUPS.DELETE_CARRIER_SUCCESS,
					PROJECT_GROUPS.MOVE_GROUPS_SUCCESS,
					PROJECT_GROUPS.GROUP_AND_DEFAULT_GROUP.SUCCESS,

					PROJECT_CARRIER_MAP.PROCURED.DELETE_SUCCESS,
					PROJECT_CARRIER_MAP.FILTER.COMPLETE,
					RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.SUCCESS,
					RECOMMENDED_CARRIERS.PROCURE_CARRIERS.SUCCESS,
					PROJECT_DETAILS.PROCURED_CARRIERS.RELOAD,
					RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.CLOSE
				)
			)
			.subscribe((response) => {
				document.getSelection().removeAllRanges();
				this.selectedProjectCarrierMapIDs = [];
				this.selectedCarrierIds = [];
				this.selectedCarrierIdSubject.next(null);
				if (this.recommendedCarriersComponent?.pannelWrapperComponent) {
					this.recommendedCarriersComponent.pannelWrapperComponent.selectedCarrierIds = [];
					if (
						this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults?.length
					) {
						this.recommendedCarriersComponent.pannelWrapperComponent.setStep(null, null);
					}
				}
				if (this.projectGroupsComponent) {
					this.projectGroupsComponent.selectedProjectCarrierMapIds = [];
					this.projectGroupsComponent.ungroupedSelectedProjectCarrierMapIds = [];
					this.store
						.select((state) => state[projectDetailsPageStateKey])
						.pipe(takeUntil(this.isDestroyed$), take(1))
						.subscribe((state) => {
							const groupIds = state.projectGroups.map((group) => group.id);
							this.projectGroupsComponent.selectedProjectGroupIds =
								this.projectGroupsComponent.selectedProjectGroupIds.filter(
									(groupId) => groupIds.indexOf(groupId) !== -1
								);
						});
				}
			});

		// CN-8312: Refresh notes list when engage succeeds (note is saved)
		// V2: Also refresh on procure success since the EngageCarriersDialog
		// flow now writes a note in the recommended→procured and engaged→procured
		// paths too.
		this.actions$
			.pipe(
				takeUntil(this.isDestroyed$),
				ofType(
					RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.SUCCESS,
					RECOMMENDED_CARRIERS.PROCURE_CARRIERS.SUCCESS,
					PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.SUCCESS
				)
			)
			.subscribe(() => {
				this.notesRefreshTrigger++;
			});
	}

	procuredCarriersSelectionUpdated() {
		this.carrierIdsToFetchNotes = this.projectGroupsComponent.selectedCarrierIds.concat(
			this.selectedCarrierIds
		);

		// Update selectedCarrierIdSubject for allocation tracking
		// Only emit carrier ID if exactly one carrier is selected in project groups
		const groupSelectedCarrierIds = this.projectGroupsComponent?.selectedCarrierIds || [];

		this.selectedCarrierIdSubject.next(
			groupSelectedCarrierIds.length === 1 ? groupSelectedCarrierIds[0] : null
		);
	}

	initializeDeadheadFilters() {
		const userDHO = this.userSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT;
		const userDHD = this.userSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT;
		const DHO = this.cargochief.getItem(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER),
			DHD = this.cargochief.getItem(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER);
		let deadhead = {
			originDeadhead: null,
			destinationDeadhead: null,
		};
		if (!this.utilService.isNullOrUndefined(userDHO)) {
			deadhead.originDeadhead = userDHO;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			deadhead.originDeadhead = JSON.parse(DHO);
		} else {
			deadhead.originDeadhead = 10;
		}
		if (!this.utilService.isNullOrUndefined(userDHD)) {
			deadhead.destinationDeadhead = userDHD;
		} else if (!this.utilService.isNullOrUndefined(DHO)) {
			deadhead.destinationDeadhead = JSON.parse(DHO);
		} else {
			deadhead.destinationDeadhead = 10;
		}
		// check from localstorage if deadhead filter exist, this is picked by request
		const { originDeadhead, destinationDeadhead } = this.capacitySearchFilterService.getDeadhead();
		if (originDeadhead) {
			deadhead.originDeadhead = originDeadhead;
		}
		if (destinationDeadhead) {
			deadhead.destinationDeadhead = destinationDeadhead;
		}
		this.carrierFiltersModel.originDeadhead = deadhead.originDeadhead;
		this.carrierFiltersModel.destinationDeadhead = deadhead.destinationDeadhead;
		this.defaultOriginDeadhead = deadhead.originDeadhead;
		this.defaultDestinationDeadhead = deadhead.destinationDeadhead;
		this.setClientFiltersForCarriers();
	}

	setTabGroupsIndex() {
		this.projectDetailsStore.loadingProjectCarrierMaps$
			.pipe(takeUntil(this.isDestroyed$), distinctUntilChanged(), skip(2), take(3))
			.subscribe((loadingProjectCarrierMaps) => {
				if (!loadingProjectCarrierMaps) {
					this.store
						.select((state) => state[projectDetailsPageStateKey])
						.pipe(takeUntil(this.isDestroyed$), take(1))
						.subscribe((state) => {
							if (this.restoredActiveTab) {
								return;
							}
							if (!state.procuredCarriersCount && this.tabGroup) {
								if (!environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS) {
									this.tabGroup.selectedIndex = 0;
								} else {
									this.tabGroup.selectedIndex = state.engagedCarriersCount ? 1 : 0;
								}
							}
						});
				}
			});
	}

	sortRecommendedCarriers() {
		if (this.recommendedCarriersComponent?.pannelWrapperComponent?.filters) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.SET.CAPACITY_SEARCH_SORT({
					capacitySearchSort: this.carrierFiltersModel.capacitySearchSort,
				})
			);

			const filters = {
				column: this.carrierFiltersModel.capacitySearchSort,
				carrierHQ: '',
			};
			this.recommendedCarriersComponent.pannelWrapperComponent.filters = { ...filters };
			this.projectDetailsEffects.sortSearchList(this.carrierFiltersModel.capacitySearchSort);
		}
		this.persistProjectFilters();
	}

	async addCarriersToGroup() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectGroups = state.projectGroups.filter(
					(group) => group.id !== this.projectGroupsComponent.selectedGroup?.id
				);
				const moveToResponse = await this.dialog
					.open(AddToGroupComponent, {
						width: '500px',
						panelClass: 'cargo_chief_dialog_container',
						data: {
							dialogTitle: 'Move to Group',
							projectGroups: projectGroups,
							closeButtonText: 'Cancel',
							submitButtonText: 'Move',
						},
					})
					.afterClosed()
					.toPromise();
				if (moveToResponse?.projectGroupId) {
					let projectGroupUpdateRequest = { projectGroups: [] },
						deleteGroupIds: string[] = [];

					// update carriers in expanded group
					projectGroupUpdateRequest.projectGroups.push({
						projectGroupId: this.projectGroupsComponent.selectedGroup.id,
						projectCarrierMapIdList:
							this.projectGroupsComponent.selectedGroup.projectCarrierMapsList
								.filter(
									(pcm) =>
										this.projectGroupsComponent.selectedProjectCarrierMapIds.indexOf(pcm.id) === -1
								)
								.map((pcm) => pcm.id),
					});
					// check if we should delete selected group
					if (!projectGroupUpdateRequest.projectGroups[0].projectCarrierMapIdList.length) {
						deleteGroupIds.push(projectGroupUpdateRequest.projectGroups[0].projectGroupId);
						projectGroupUpdateRequest.projectGroups = [];
					}
					// move carriers to new group
					const selectedGroup = state.projectGroups.find(
						(group) => group.id === moveToResponse.projectGroupId
					);
					projectGroupUpdateRequest.projectGroups.push({
						projectGroupId: moveToResponse.projectGroupId,
						projectCarrierMapIdList:
							this.projectGroupsComponent.selectedProjectCarrierMapIds.concat(
								selectedGroup.projectCarrierMapsList.map((pcm) => pcm.id)
							),
					});
					this.store.dispatch(
						PROJECT_GROUPS.ADD_TO_GROUP.ADD({
							updateGroups: projectGroupUpdateRequest,
							deleteGroupIds,
						})
					);
				}
			});
	}

	setOriginDeadhead(value) {
		let originDeadhead = this.carrierFiltersModel.originDeadhead;
		originDeadhead += value;
		if (originDeadhead >= 0) {
			this.carrierFiltersModel.originDeadhead = originDeadhead;
		}
		this.onDeadheadChange(
			CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
			this.carrierFiltersModel.originDeadhead
		);
	}

	setDestinatioDeadhead(value) {
		let destinationDeadhead = this.carrierFiltersModel.destinationDeadhead;
		destinationDeadhead += value;
		if (destinationDeadhead >= 0) {
			this.carrierFiltersModel.destinationDeadhead = destinationDeadhead;
		}
		this.onDeadheadChange(
			CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
			this.carrierFiltersModel.originDeadhead
		);
	}

	onDeadheadChange(key, value) {
		this.cargochief.setItem({ [key]: value });
	}

	setPowerUnits(value) {
		let minTruckCount = this.carrierFiltersModel.powerUnits;
		minTruckCount += value;
		if (minTruckCount >= 0) {
			this.carrierFiltersModel.powerUnits = minTruckCount;
		} else {
			this.carrierFiltersModel.powerUnits = 0;
		}
	}

	setMinLoadsPerWeek(value) {
		let minLoadsPerWeek = this.carrierFiltersModel.minLoadsPerWeek;
		minLoadsPerWeek += value;
		if (minLoadsPerWeek >= 0) {
			this.carrierFiltersModel.minLoadsPerWeek = minLoadsPerWeek;
		} else {
			this.carrierFiltersModel.minLoadsPerWeek = 0;
		}
	}

	removeHQFilter() {
		this.carrierFiltersModel.carrierHQ = '';
	}

	applyFilter() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				this.setClientFiltersForCarriers();

				if (this.tabGroup?.selectedIndex === 0) {
					// check if we should run capacity search
					if (
						this.carrierFiltersModel.originDeadhead !== state.originDeadhead ||
						this.carrierFiltersModel.destinationDeadhead !== state.destinationDeadhead ||
						this.carrierFiltersModel.minLoadsPerWeek !== state.minLoadsPerWeek
					) {
						this.recommendedCarriersComponent.initiateSearch();
					}
					// check for carrierHQ  filter
					if (this.carrierFiltersModel.carrierHQ !== state.carrierHQ) {
						if (this.carrierFiltersModel.carrierHQ.length) {
							this.recommendedCarriersEffects.filterByHQ(
								this.carrierFiltersModel.carrierHQ,
								this.recommendedCarriersComponent.searchFormData
							);
						} else {
							this.recommendedCarriersEffects.removeHQFilter();
						}
					}
				}
				this.store.dispatch(PROJECT_CARRIER_MAP.FILTER.APPLY({}));
				this.persistProjectFilters();
			});
	}

	setClientFiltersForCarriers() {
		const textSplit = this.carrierFiltersModel.carriersSearchText.split(',');
		// CN-8312: mcOrDot collects bare numeric tokens (e.g. an MC or DOT value
		// copied from a carrier card without an `mc:` / `dot:` prefix). The
		// filter effect ANDs mc with dot, so dropping a numeric token into either
		// alone would never match a carrier (since MC and DOT are different
		// numbers). Routing it through mcOrDot lets the effect do an OR match.
		let payload = { mc: '', dot: '', mcOrDot: '', businessName: '' };
		textSplit?.forEach((text) => {
			if (this.carrierSearchHelper.isKey(text, 'mc')) {
				payload.mc = this.carrierSearchHelper.splitOutValue(text);
			} else if (this.carrierSearchHelper.isKey(text, 'dot')) {
				payload.dot = this.carrierSearchHelper.splitOutValue(text);
			} else if (this.utilService.isValidNumber(text.trim())) {
				payload.mcOrDot = text.trim();
			} else {
				payload.businessName = text.trim();
			}
		});
		this.store.dispatch(
			RECOMMENDED_CARRIERS.SET.CARRIER_SEARCH({
				originDeadhead: this.carrierFiltersModel.originDeadhead,
				destinationDeadhead: this.carrierFiltersModel.destinationDeadhead,
				powerUnits: this.carrierFiltersModel.powerUnits,
				minLoadsPerWeek: this.carrierFiltersModel.minLoadsPerWeek,
				ratesOnly: this.carrierFiltersModel.ratesOnly,
				mc: payload.mc,
				dot: payload.dot,
				mcOrDot: payload.mcOrDot,
				businessName: payload.businessName,
				carrierHQ: this.carrierFiltersModel.carrierHQ,
				myCarriers: this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[1],
				outOfNetworkCarriers:
					this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[2],
				carrierSearchString: this.carrierFiltersModel.carriersSearchText,
				qualityFilter: this.carrierFiltersModel.qualityFilter,
			})
		);
		this.updateFilterIndicator();
	}

	isFilterChange(filters: any) {
		// carrierSearchString already encodes mc/dot/mcOrDot/businessName parsing,
		// so comparing it is enough to detect parser-output changes too.
		if (
			filters.originDeadhead === this.carrierFiltersModel.originDeadhead &&
			filters.destinationDeadhead === this.carrierFiltersModel.destinationDeadhead &&
			filters.powerUnits === this.carrierFiltersModel.powerUnits &&
			filters.minLoadsPerWeek === this.carrierFiltersModel.minLoadsPerWeek &&
			filters.ratesOnly === this.carrierFiltersModel.ratesOnly &&
			filters.carrierSearchString === this.carrierFiltersModel.carriersSearchText &&
			filters.carrierHQ === this.carrierFiltersModel.carrierHQ &&
			filters.myCarriers ===
				(this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[1]) &&
			filters.outOfNetworkCarriers ===
				(this.carrierFiltersModel.carrierSelected === CAPACITY_SEARCH_FILTER.CARRIERS[2]) &&
			filters.qualityFilter === this.carrierFiltersModel.qualityFilter
		) {
			return true;
		}
		return false;
	}

	navigateToCapacitySearch(): void {
		this.router.navigate([`capacity/`]);
	}

	async mergeGroups() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				const selectedProjectGroups = state.projectGroups.filter(
					(group) => this.projectGroupsComponent.selectedProjectGroupIds.indexOf(group.id) !== -1
				);
				let projectCarrierMapIdList: string[] = selectedProjectGroups[0].projectCarrierMapsList.map(
						(pcm) => pcm.id
					),
					deleteGroupIds: string[] = [],
					projectGroupUpdateRequest = { projectGroups: [] };
				selectedProjectGroups.forEach((group, index) => {
					if (index) {
						projectCarrierMapIdList = projectCarrierMapIdList.concat(
							group.projectCarrierMapsList.map((pcm) => pcm.id)
						);
						if (!group.systemGroup) {
							deleteGroupIds.push(group.id);
						}
					}
				});
				projectGroupUpdateRequest.projectGroups.push({
					projectGroupId: selectedProjectGroups[0].id,
					projectCarrierMapIdList,
				});

				this.store.dispatch(
					PROJECT_GROUPS.ADD_TO_GROUP.ADD({
						updateGroups: projectGroupUpdateRequest,
						deleteGroupIds,
					})
				);
			});
	}

	onRecommendedTabDrop(event: any) {
		if (!this.tabGroup?.selectedIndex) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		if (this.tabGroup.selectedIndex === 2) {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.PROCURED.DELETE({
					projectCarrierMapIDs: selectedIds,
					noteType: this.getNoteType(),
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.DELETE_PROJECT_CARRIER_MAP.DELETE({
					projectCarrierMapIDs: selectedIds,
				})
			);
		}
	}

	onEngagedTabDrop(event: any) {
		// CN-8312: Handle V3 layout where tabGroup doesn't exist
		if (this.useLayoutV3 && !this.isWaterfallOrDedicatedLaneProject) {
			const selectedIds: string[] = this.getDroppedCarrierIds(event);
			// In V3, check if IDs are carrier IDs (from Recommended) or projectCarrierMap IDs (from Procured)
			const isFromRecommended = this.isDropFromRecommended(selectedIds);
			if (isFromRecommended) {
				this.recommendedToEngage(selectedIds);
			} else {
				// From Procured column
				this.store.dispatch(
					PROJECT_CARRIER_MAP.PROCURED_TO_ENGAGED.CREATE({
						projectCarrierMapIds: selectedIds,
					})
				);
			}
			return;
		}

		// V1/V2 tab-based logic
		if (this.tabGroup?.selectedIndex === 1) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		if (!this.tabGroup.selectedIndex) {
			this.recommendedToEngage(selectedIds);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.PROCURED_TO_ENGAGED.CREATE({
					projectCarrierMapIds: selectedIds,
				})
			);
		}
	}

	onProcuredTabDrop(event: any) {
		// CN-8312: Handle V3 layout where tabGroup doesn't exist
		if (this.useLayoutV3 && !this.isWaterfallOrDedicatedLaneProject) {
			const selectedIds: string[] = this.getDroppedCarrierIds(event);
			// In V3, check if IDs are carrier IDs (from Recommended) or projectCarrierMap IDs (from Engaged)
			const isFromRecommended = this.isDropFromRecommended(selectedIds);
			// Drag is Kanban's only procure path, so it carries the EngageCarriersDialog
			// flow that the tab layouts get below. Workflow is already excluded above.
			if (isFromRecommended) {
				this.store.dispatch(
					RECOMMENDED_CARRIERS.PROCURE_CARRIERS.CREATE({
						selectedCarrierIds: selectedIds,
						useEngageDialog: true,
					})
				);
			} else {
				// From Engaged column
				this.store.dispatch(
					PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.CREATE({
						projectCarrierMapIds: selectedIds,
						useEngageDialog: true,
					})
				);
			}
			return;
		}

		// Tab-based logic
		if (this.showProcuredTabOptions(this.tabGroup.selectedIndex)) {
			return;
		}
		const selectedIds: string[] = this.getDroppedCarrierIds(event);
		// CN-8312 V2: drag-to-Procured uses the EngageCarriersDialog flow
		// (rate + notes + contact typeahead → note + feedback writes).
		const useEngageDialog = !this.isWaterfallOrDedicatedLaneProject;
		if (!this.tabGroup.selectedIndex) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.PROCURE_CARRIERS.CREATE({
					selectedCarrierIds: selectedIds,
					useEngageDialog,
				})
			);
		} else {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.ENGAGE_TO_PROCURE.CREATE({
					projectCarrierMapIds: selectedIds,
					useEngageDialog,
				})
			);
		}
	}

	getDroppedCarrierIds(event: any): string[] {
		event.preventDefault();
		return event.dataTransfer.getData('carrierId').split(',');
	}

	/**
	 * CN-8312: Determines if dropped IDs are from the Recommended column.
	 * Recommended column uses actual carrier IDs, while Engaged/Procured use projectCarrierMap IDs.
	 */
	isDropFromRecommended(droppedIds: string[]): boolean {
		if (!droppedIds?.length) {
			return false;
		}
		// Check if the first dropped ID exists in the recommended carriers list
		const firstId = droppedIds[0];
		const isInRecommended =
			this.recommendedCarriersComponent?.pannelWrapperComponent?.truckSearchResultCopy?.some(
				(search) => search.carrierId === firstId
			);
		return isInRecommended || false;
	}

	recommendedToEngage(selectedCarrierIds: string[]) {
		if (this.userSettings.HIDE_ENGAGE_CARRIER_DIALOG) {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.CREATE({
					carrierIDs: selectedCarrierIds,
					desiredPrice: null,
					carrierRespondedAt: null,
					status: PROJECT_CARRIER_MAP_STATUS.IN_PROGRESS,
				})
			);
		} else {
			this.store.dispatch(
				RECOMMENDED_CARRIERS.ENGAGE_WITH_CARRIERS.START({
					selectedCarrierIds: selectedCarrierIds,
					noteType: this.getNoteType(),
					showRateForm: true,
					showNotes: true,
				})
			);
		}
	}

	editProjectGroup() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				const selectedGroupId = this.projectGroupsComponent.selectedProjectGroupIds[0];
				const selectedGroup = state.projectGroups.find((group) => group.id === selectedGroupId);
				const projectCarrierMapsList = selectedGroup.projectCarrierMapsList.map((pcm) => pcm.id);
				let delayByMinutesList = state.projectGroups.map((group) => group.delayByMinutes);
				delayByMinutesList.splice(delayByMinutesList.indexOf(selectedGroup.delayByMinutes), 1);
				if (selectedGroup) {
					this.store.dispatch(
						PROJECT_GROUPS.UPDATE_GROUP.UPDATE({
							editGroup: true,
							group: selectedGroup,
							projectId: selectedGroup?.projectId,
							projectCarrierMapIds: projectCarrierMapsList,
							delayByMinutesList,
							dialogTitle: 'Edit Group',
							submitButtonText: 'Update',
							groupsCount: state.projectGroups.length,
							groupNames: state.projectGroups
								.filter((group) => group.name && group.name !== selectedGroup.name)
								.map((group) => group.name.toLowerCase()),
						})
					);
				}
			});
	}

	async addDesiredRate() {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectCarrierMap = null,
					selectedPcmId = null;

				// Check Allocations tab selection first
				if (this.selectedAllocatedCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedAllocatedCarrierMapIDs[0];
				} else if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}

				projectCarrierMap = state.allProjectCarrierMapsList.find((pcm) => pcm.id === selectedPcmId);
				if (projectCarrierMap) {
					this.store.dispatch(PROJECT_CARRIER_MAP.UPDATE_RATE.OPEN_DIALOG({ projectCarrierMap }));
				}
			});
	}

	openBADialog() {
		this.store.dispatch(
			PROJECT_DETAILS.BA.OPEN_DIALOG({
				lanePricing: this.lanePricing,
				greenScreenRate: this.pricingComponent?.greenScreenRate,
			})
		);
	}

	moreThanOneProjectCarrierMapSelected(projectGroupsLength: number): boolean {
		// If there are project groups (Waterfall with groups), use the project-groups component's selection
		if (projectGroupsLength && this.projectGroupsComponent) {
			return this.projectGroupsComponent.selectedProjectCarrierMapIds.length !== 1;
		}

		// Otherwise use the component's own selection (for Recommended tab or Procured tab without groups)
		return this.selectedProjectCarrierMapIDs.length !== 1;
	}

	reportDataAction(dataType: string) {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectCarrierMap = null,
					selectedPcmId = null;
				if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}
				projectCarrierMap = state.allProjectCarrierMapsList.find((pcm) => pcm.id === selectedPcmId);
				if (projectCarrierMap) {
					this.engagedCarriersComponent?.reportDataAction(dataType, projectCarrierMap.carrier);
				}
			});
	}

	/**
	 * CN-8312: Determines if the currently selected carrier is from the Recommended column.
	 * Handles both V1/V2 (tab-based) and V3 (column-based) layouts.
	 */
	isSelectedCarrierFromRecommended(): boolean {
		// V1/V2 layouts: use tab index
		if (this.tabGroup) {
			return this.tabGroup.selectedIndex === 0;
		}

		// V3 layout: check if the selected carrier exists in capacitySearchResults (Recommended)
		// If carrierIdsToFetchNotes is empty or has multiple carriers, we can't determine source
		if (this.carrierIdsToFetchNotes.length !== 1) {
			return false;
		}

		const carrierId = this.carrierIdsToFetchNotes[0];
		const isInRecommended =
			this.recommendedCarriersComponent?.pannelWrapperComponent?.truckSearchResultCopy?.some(
				(search) => search.carrierId === carrierId
			);

		return isInRecommended || false;
	}

	getFromRecommendedCarrierOrProjectCarrierMap(
		allProjectCarrierMapsList: ProjectCarrierMapDTO[],
		attribute: 'mc' | 'dot' | 'customerCarrier'
	) {
		// CN-8312: Use helper that handles both V1/V2 tabs and V3 columns
		const from = this.isSelectedCarrierFromRecommended()
			? 'fromRecommendedCarrier'
			: 'fromProjectCarrierMap';
		const attributeMap = {
			mc: { fromRecommendedCarrier: 'firmMc', fromProjectCarrierMap: 'mc' },
			dot: { fromRecommendedCarrier: 'firmDot', fromProjectCarrierMap: 'dot' },
			customerCarrier: {
				fromRecommendedCarrier: 'customerCarrier',
				fromProjectCarrierMap: 'customerCarrier',
			},
		};
		const attributeToFetch = attributeMap[attribute][from];
		if (from == 'fromRecommendedCarrier') {
			const carrier = this.getRecommendedCarrierOpened();
			if (IS_NULL_OR_UNDEFINED(carrier)) {
				return null;
			}
			return carrier[attributeToFetch];
		} else {
			const projectCarrierMap = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			if (IS_NULL_OR_UNDEFINED(projectCarrierMap)) {
				return null;
			}
			return projectCarrierMap[attributeToFetch];
		}
	}

	getCarrierMc(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(allProjectCarrierMapsList, 'mc');
	}

	getCarrierDot(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(allProjectCarrierMapsList, 'dot');
	}

	getCarrierQuality(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		// CN-8312: Use helper that handles both V1/V2 tabs and V3 columns
		if (this.isSelectedCarrierFromRecommended()) {
			const carrier = this.getRecommendedCarrierOpened();
			return carrier;
		} else {
			const projectCarrierMap = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			return this.getCarrierQualityObject(projectCarrierMap);
		}
	}

	getRecommendedCarrierOpened(): any {
		const carrier =
			this.recommendedCarriersComponent?.pannelWrapperComponent?.truckSearchResultCopy.find(
				(search) => search.carrierId == this.carrierIdsToFetchNotes[0]
			);
		return carrier;
	}

	getProcuredCarrierOpened(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		if (IS_NULL_OR_UNDEFINED(allProjectCarrierMapsList)) {
			return null;
		}
		const projectCarrierMap = allProjectCarrierMapsList?.find(
			(projectCarrierMap) => projectCarrierMap?.carrier?.id == this.carrierIdsToFetchNotes[0]
		);
		return projectCarrierMap?.carrier;
	}

	getSelectedCarrierForTab(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		// CN-8312: Use helper that handles both V1/V2 tabs and V3 columns
		if (this.isSelectedCarrierFromRecommended()) {
			return this.getRecommendedCarrierOpened();
		} else {
			const accountId = this.cargochief.ACCOUNT_ID;
			const carrier = this.getProcuredCarrierOpened(allProjectCarrierMapsList);
			const accountCarrierMap = carrier?.accountCarrierMaps?.find(
				(acm) => acm.accountId == accountId
			);
			if (
				IS_NOT_NULL_OR_UNDEFINED(accountCarrierMap) &&
				IS_NOT_EMPTY(accountCarrierMap.vettingOverallDisplay)
			) {
				return accountCarrierMap;
			} else if (IS_NOT_EMPTY(carrier?.vettingOverallDisplay)) {
				return {
					ccBookingRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccBookingRate),
					ccEngagementRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccEngagementRate),
					ccFalloffRateDisplay: FORMAT_SCORE_PERCENTAGE(carrier?.ccFalloffRate),
					ccTotalBookedLoads: carrier?.ccTotalBookedLoads,
					ccScore: carrier?.ccScore,
					vettingAuthorityDisplay: carrier?.vettingAuthorityDisplay,
					vettingInsuranceDisplay: carrier?.vettingInsuranceDisplay,
					vettingOperationsDisplay: carrier?.vettingOperationsDisplay,
					vettingSafetyDisplay: carrier?.vettingSafetyDisplay,
					vettingOverallDisplay: carrier?.vettingOverallDisplay,
					lastVettingTime: carrier?.lastVettingTime,
				};
			}
			return {};
		}
	}

	vettingOverallDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOverallDisplay;
	}

	vettingAuthorityDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingAuthorityDisplay;
	}

	vettingInsuranceDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingInsuranceDisplay;
	}

	vettingOperationsDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOperationsDisplay;
	}

	vettingSafetyDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingSafetyDisplay;
	}

	vettingOtherDisplay(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.vettingOtherDisplay;
	}

	infractionDetails(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.infractionDetails;
	}

	formatCarrierVettingRate(rate: number | null | undefined): string {
		return FORMAT_SCORE_PERCENTAGE(rate);
	}

	getCarrierQualityObject(projectCarrierMap) {
		const accountCarrierMap = projectCarrierMap?.accountCarrierMaps?.find(
			(acm) => acm.accountId === this.cargochief.ACCOUNT_ID
		);
		return {
			ccBookingRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccBookingRate),
			ccEngagementRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccEngagementRate),
			ccFalloffRateDisplay: this.formatCarrierVettingRate(accountCarrierMap?.ccFalloffRate),
			ccTotalBookedLoads: accountCarrierMap?.ccTotalBookedLoads,
			// CN-8744: fall back to the carrier-level cc_score when this account has no ACM
			// score, so the displayed band matches the invite gate (and the quality filter).
			ccScore: RESOLVE_EFFECTIVE_CC_SCORE(projectCarrierMap, this.cargochief.ACCOUNT_ID),
			vettingSource: accountCarrierMap?.vettingSource,
			vettingSourceId: accountCarrierMap?.vettingSourceId,
			carrierOnboardedOn: accountCarrierMap?.carrierOnboardedOn,
		};
	}

	getIsCarrierInNetwork(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getFromRecommendedCarrierOrProjectCarrierMap(
			allProjectCarrierMapsList,
			'customerCarrier'
		);
	}

	getLastVettingTime(allProjectCarrierMapsList: ProjectCarrierMapDTO[]) {
		return this.getSelectedCarrierForTab(allProjectCarrierMapsList)?.lastVettingTime;
	}

	/**
	 * CN-8312: load the focused carrier's full contact list for the Carrier tray
	 * Contacts section (same /contacts source the lane-details full profile and
	 * the engage dialog typeahead use). carrierId is the value pushed through
	 * selectedCarrierIdSubject — null when zero/multiple carriers are focused.
	 * Skips the GET when the list is already loaded for that carrier.
	 */
	loadTrayContacts(carrierId: string | null): void {
		if (!carrierId) {
			this.trayContactList = null;
			this.trayContactsCarrierId = null;
			return;
		}
		if (carrierId === this.trayContactsCarrierId) {
			return;
		}
		this.trayContactsCarrierId = carrierId;
		this.trayContactList = null;
		this.restService
			.GET(this.urlService.contactsUrl(carrierId))
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe(
				(result) => {
					// Guard against an out-of-order response after focus moved on.
					if (carrierId === this.trayContactsCarrierId) {
						this.trayContactList = (result?.['data'] || []) as ContactsTable[];
					}
				},
				() => {
					if (carrierId === this.trayContactsCarrierId) {
						this.trayContactList = [];
					}
				}
			);
	}

	/** CN-8312: display name for a tray contact — full name, else email. */
	trayContactName(contact: ContactsTable): string {
		const name = `${contact?.firstName || ''} ${contact?.lastName || ''}`.trim();
		return name || contact?.fullName || contact?.emailAddress || 'Contact';
	}

	/** CN-8312: best available phone for a tray contact. */
	trayContactPhone(contact: ContactsTable): string {
		return contact?.phone || contact?.mobile || contact?.phoneNumber || null;
	}

	/**
	 * CN-8312: validated-contact tooltip. Reuses the shared EMAIL_VALIDATED_TOOLTIP
	 * helper (the carrier-contacts "Validated" column uses the same), shown on the
	 * blue check_circle when contact.vettingAuthorized is true.
	 */
	contactValidatedTooltip(contact: ContactsTable): string {
		return EMAIL_VALIDATED_TOOLTIP(contact as any);
	}

	/**
	 * CN-8312: the tray Contacts to render — the loaded list, optionally filtered
	 * to validated contacts only (client-side, no server call). Returns [] while
	 * loading (trayContactList null).
	 */
	get displayedTrayContacts(): ContactsTable[] {
		if (!this.trayContactList) {
			return [];
		}
		return this.showValidatedContactsOnly
			? this.trayContactList.filter((c) => c.vettingAuthorized)
			: this.trayContactList;
	}

	/** CN-8312: trackBy for the tray contacts *ngFor (filter toggles re-render rows). */
	trackTrayContactById(_index: number, contact: ContactsTable): string {
		return contact?.id;
	}

	/**
	 * CN-8312: "Log a call" for the carrier focused in the tray. Opens the same
	 * EngageCarriersDialog used by the project Engage flow and the load-details
	 * contact actions, in log-only mode: on save it records a carrier note (which
	 * surfaces in the tray Notes panel and bumps Last Contact server-side) and does
	 * NOT move the carrier between columns. Wired to the phone / email / log-call
	 * icons in the Carrier tray; the phone/email anchors also fire their native
	 * tel:/mailto: links. When invoked from a specific contact row, that contact
	 * is passed so the dialog pre-fills "Who did you talk to?".
	 */
	logCallForFocusedCarrier(contact?: ContactsTable): void {
		if (this.carrierIdsToFetchNotes.length !== 1) {
			return;
		}
		const carrierId = this.carrierIdsToFetchNotes[0];
		const dialogRef = this.dialog.open(EngageCarriersDialogComponent, {
			width: '550px',
			panelClass: 'cargo_chief_dialog_container',
			data: {
				dialogHeader: 'Log a call',
				submitButtonText: 'Save',
				showRateForm: true,
				showNotes: true,
				carrierIds: [carrierId],
				contactNameOptional: false,
				// CN-8312: pre-select the clicked contact in the dialog typeahead.
				selectedContact: contact || null,
			},
		});

		dialogRef
			.afterClosed()
			.pipe(takeUntil(this.isDestroyed$))
			.subscribe((result: any) => {
				if (!result) {
					return;
				}
				const notes = this.composeCallNote(result);
				if (!notes) {
					return;
				}
				// Mirror the carrier-outreach / recommended-list logCall: a carrier-level
				// note (no projectId) so it shows in this project's carrier Notes panel
				// (note-list keeps notes whose projectId is null) and bumps Last Contact.
				this.restService
					.POST(this.urlService.addCarrierNotes(), {
						carrierId,
						notes,
						accountId: this.cargochief.ACCOUNT_ID,
						userId: this.cargochief.USER_ID,
						// Canonical CarrierNotesSourceEnum value (cargochief-sdk-carrier-hub).
						source: 'PROCUREMENT_FLOW',
						contactMade: true,
					})
					.pipe(takeUntil(this.isDestroyed$))
					.subscribe(
						(response) => {
							// Update the Notes panel + ribbon Notes badge immediately,
							// without a page refresh. The /carrierNotes POST returns the
							// created note; insert it straight into the (always-mounted)
							// carrier note list via addNote(), which prepends it and emits
							// the new count — avoiding the read-after-write lag a re-fetch
							// would hit. Fall back to a refresh trigger if the response
							// didn't include a usable note or the list isn't mounted.
							const createdNote = response?.['data'];
							if (createdNote?.id && this.trayCarrierNoteList) {
								this.trayCarrierNoteList.addNote(createdNote);
							} else {
								this.notesRefreshTrigger++;
							}
							this.utilService.showSnackbar(
								'Call logged.',
								SNACKBAR.SUCCESS,
								SNACKBAR.ACTION
							);
						},
						() => {
							this.utilService.showSnackbar(
								'Unable to save the call log. Try again.',
								SNACKBAR.ERROR,
								SNACKBAR.ACTION
							);
						}
					);
			});
	}

	/**
	 * CN-8312: fold the EngageCarriersDialog result (contact, quoted price, responded
	 * date, status, free-form notes) into a single note body. Mirrors the formatting
	 * in LogCallService / the carrier-outreach widget so a logged call reads the same
	 * everywhere it was captured.
	 */
	private composeCallNote(result: any): string {
		const lines: string[] = [];
		if (result?.contactName) {
			lines.push(`Talked To: ${result.contactName}`);
		}
		const priceCents = Number(result?.desiredPrice);
		if (Number.isFinite(priceCents) && priceCents > 0) {
			lines.push(`Quoted: $${(priceCents / 100).toLocaleString('en-US', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
			})}`);
		}
		if (result?.status) {
			lines.push(`Status: ${this.humanizeStatus(result.status)}`);
		}
		if (result?.carrierRespondedAt) {
			lines.push(`Responded: ${result.carrierRespondedAt}`);
		}
		if (result?.notes) {
			lines.push(result.notes);
		}
		return lines.join('\n');
	}

	private humanizeStatus(status: string): string {
		return status
			.toString()
			.toLowerCase()
			.split('_')
			.map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
			.join(' ');
	}

	getProcuredCarriersList(store): ProjectCarrierMapDTO[] {
		let result = [];
		if (store?.projectGroups?.length) {
			store.projectGroups.forEach((group) => {
				result = result.concat(group.projectCarrierMapsList);
			});
		}
		if (store?.procuredCarriersList?.length) {
			result = result.concat(store.procuredCarriersList);
		}
		return result;
	}

	isRecommendedTab(): boolean {
		return this.tabGroup?.selectedIndex == 0 && !this.carrierIdsToFetchNotes.length;
	}

	/**
	 * Check if we're on the Allocations tab.
	 * The Allocations tab is only visible for Workflow projects (WATERFALL or DEDICATED_LANE).
	 * Tab order for Workflow projects: Recommended (0), Allocations (1), Waterfall (2), Filter/Actions (3)
	 */
	isAllocationsTab(): boolean {
		return (
			this.isWaterfallOrDedicatedLaneProject &&
			this.tabGroup?.selectedIndex == 1 &&
			!this.carrierIdsToFetchNotes.length
		);
	}

	isEngagedTab(store: any): boolean {
		return (
			environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS &&
			!this.isWaterfallOrDedicatedLaneProject &&
			!this.carrierIdsToFetchNotes.length &&
			this.tabGroup?.selectedIndex == 1 &&
			!store.loadingProjectCarrierMaps
		);
	}

	isProcuredTab(store: any): boolean {
		// CN-8312: V3 layout doesn't have tabs - default to showing procured stats when no carrier selected
		if (this.useLayoutV3 && !this.isWaterfallOrDedicatedLaneProject) {
			return !this.carrierIdsToFetchNotes.length && !store.loadingProjectCarrierMaps;
		}

		// For Workflow projects: Recommended (0), Allocations (1), Waterfall (2)
		// For non-Workflow with Engaged: Recommended (0), Engaged (1), Procured (2)
		// For non-Workflow without Engaged: Recommended (0), Procured (1)
		let procuredIndex: number;
		if (this.isWaterfallOrDedicatedLaneProject) {
			procuredIndex = 2; // Waterfall tab after Allocations
		} else if (environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS) {
			procuredIndex = 2; // Procured tab after Engaged
		} else {
			procuredIndex = 1; // Procured tab directly after Recommended
		}

		return (
			this.tabGroup?.selectedIndex == procuredIndex &&
			!this.carrierIdsToFetchNotes.length &&
			!store.loadingProjectCarrierMaps
		);
	}

	addCarrierContact(): void {
		this.sharedService.sendAddNewProjectCarrierMapContactEvent({
			carrierId: this.carrierIdsToFetchNotes[0],
		});
	}

	exportProcuredCarriers(): void {
		this.store.dispatch(PROJECT_DETAILS.DOWNLOAD.PROCURED_CARRIERS({}));
	}

	exportEngagedCarriers(): void {
		this.store.dispatch(PROJECT_DETAILS.DOWNLOAD.ENGAGEED_CARRIERS({}));
	}

	exportAllocatedCarriers(): void {
		this.store.dispatch(PROJECT_DETAILS.DOWNLOAD.ALLOCATED_CARRIERS({}));
	}

	async getSelectedProjectCarrierMaps() {
		const projectGroups = await firstValueFrom(this.projectDetailsStore.projectGroups$);
		const projectGroupsLength = projectGroups.length;
		let selectedProjectCarrierMaps = [];
		if (projectGroupsLength) {
			if (this.projectGroupsComponent?.selectedCarrierIds?.length) {
				const pcmList = this.projectGroupsComponent.selectedGroup.projectCarrierMapsList;
				selectedProjectCarrierMaps = pcmList.filter(
					(pcm) => this.projectGroupsComponent.selectedProjectCarrierMapIds.indexOf(pcm?.id) !== -1
				);
			} else {
				projectGroups.forEach((group) => {
					selectedProjectCarrierMaps = selectedProjectCarrierMaps.concat(
						group.projectCarrierMapsList
					);
				});
			}
		} else {
			if (this.selectedProjectCarrierMapIDs?.length) {
				selectedProjectCarrierMaps = this.procuredCarriersComponent?.projectCarrierMapList.filter(
					(pcm) => this.selectedProjectCarrierMapIDs?.indexOf(pcm?.id) != -1
				);
			} else {
				selectedProjectCarrierMaps = await firstValueFrom(
					this.projectDetailsStore.procuredCarriersList$
				);
			}
		}
		return selectedProjectCarrierMaps;
	}

	async onAllowBookNowClick() {
		// check if any procured carriers selected
		let baConfig = this.baConfigService.getBAConfig();
		try {
			let baConfigData = JSON.parse(baConfig.data);
			if (!baConfigData?.bookNowData) {
				baConfigData['bookNowData'] = [];
			}
			let bookNowData = baConfigData.bookNowData;

			const bookNowCarriersList =
				bookNowData?.find((config) => config.attribute == 'carrier')?.data || [];

			let bookNowCarriersListRequest = [],
				selectedProjectCarrierMaps = await this.getSelectedProjectCarrierMaps();

			if (selectedProjectCarrierMaps.length) {
				selectedProjectCarrierMaps.forEach((pcm) => {
					const carrierFound = bookNowCarriersList?.find((c) => c.id == pcm?.carrier?.id);
					if (!carrierFound) {
						bookNowCarriersListRequest.push({
							id: pcm?.carrier?.id,
							businessName: pcm?.carrier?.businessName,
						});
					}
				});
				if (bookNowCarriersListRequest.length) {
					let bookNowCarrierData = bookNowData?.find((config) => config.attribute == 'carrier');
					if (!bookNowCarrierData) {
						bookNowCarrierData = {
							attribute: 'carrier',
							operator: 'in',
							data: bookNowCarriersListRequest,
						};
						bookNowData.push(bookNowCarrierData);
					} else {
						bookNowData.forEach((config) => {
							if (config.attribute == 'carrier') {
								config.data = config.data.concat(bookNowCarriersListRequest);
							}
						});
					}
					bookNowData.forEach((config) => {
						config.data = config.data.filter(
							(value, index, self) => index === self.findIndex((c) => c.id === value.id)
						);
					});
					baConfigData['bookNowData'] = bookNowData;
					baConfig['data'] = baConfigData;
					const successMessage = `${bookNowCarriersListRequest.length} carrier${bookNowCarriersListRequest.length > 1 ? 's' : ''} added to Book Now.`;
					this.baConfigService.updateBaConfig(baConfig, successMessage);
				} else {
					this.utilService.showSnackbar(
						'Book Now configuration is updated.',
						SNACKBAR.SUCCESS,
						SNACKBAR.ACTION
					);
				}
			}
		} catch (error) {
			console.warn('onAllowBookNowClick failed: ', error);
			this.utilService.showSnackbar(
				'Failed to update Book Now configuration.',
				SNACKBAR.WARNING,
				SNACKBAR.ACTION
			);
		}
	}

	async sendProcuredCarriersEmail() {
		let selectedProjectCarrierMaps = await this.getSelectedProjectCarrierMaps();
		if (!selectedProjectCarrierMaps?.length) {
			selectedProjectCarrierMaps = await firstValueFrom(
				this.projectDetailsStore.procuredCarriersList$
			);
		}
		const emailedPCMIds = [],
			newPCMIdsToEmail = [];
		selectedProjectCarrierMaps.forEach((pcm: ProjectCarrierMapDTO) => {
			if (!pcm.procuredEmailDeliveredAt) {
				newPCMIdsToEmail.push(pcm.id);
			} else {
				emailedPCMIds.push(pcm.id);
			}
		});
		if (emailedPCMIds?.length) {
			const multipleCarriersMailedBefore = emailedPCMIds.length > 1;
			this.utilService.showSnackbar(
				`Email${multipleCarriersMailedBefore ? 's' : ''} not sent to ${emailedPCMIds.length} carrier${multipleCarriersMailedBefore ? 's as they' : ' who'}  were already contacted.`,
				SNACKBAR.WARNING,
				SNACKBAR.ACTION
			);
		}
		if (newPCMIdsToEmail?.length) {
			this.store.dispatch(
				PROJECT_CARRIER_MAP.SEND_PROCURED_CARRIERS_EMAIL.SEND({
					projectId: this.projectId,
					procuredProjectCarrierMapIds: newPCMIdsToEmail,
				})
			);
		}
	}

	/**
	 * Check if the currently selected carrier has an allocation.
	 * Used in the template to show Add vs Edit Allocation buttons.
	 * Uses combineLatest to avoid NG0100 errors by reacting to both streams.
	 */
	selectedCarrierHasAllocation$: Observable<boolean> = combineLatest([
		this.selectedCarrierIdSubject.asObservable(),
		this.projectDetailsStore.carrierAllocationsMap$,
	]).pipe(
		map(([carrierId, allocationsMap]) => {
			return carrierId ? !!allocationsMap?.[carrierId] : false;
		})
	);

	/**
	 * CN-8312 V2: client-side sort comparator. Uses the same field names as the
	 * Recommended sort (match / frequency / quality) so the UI is consistent across
	 * tabs. 'match' is the default and matches the natural store order so V1 isn't
	 * affected.
	 */
	private engagedProcuredSortComparator(sort: string) {
		return (a: any, b: any): number => {
			if (sort === RANGE_FILTERS.SORT.FREQUENCY) {
				const af = parseFloat(a?.frequency) || 0;
				const bf = parseFloat(b?.frequency) || 0;
				return bf - af;
			}
			if (sort === RANGE_FILTERS.SORT.QUALITY) {
				// Pull the per-account ccScore (the same field Quality Score is rendered
				// from). Higher ccScore numbers sort first; missing scores sink to the bottom.
				const ascore =
					a?.carrier?.accountCarrierMaps?.[0]?.ccScore ?? a?.carrier?.ccScore ?? 0;
				const bscore =
					b?.carrier?.accountCarrierMaps?.[0]?.ccScore ?? b?.carrier?.ccScore ?? 0;
				return (Number(bscore) || 0) - (Number(ascore) || 0);
			}
			if (sort === 'lastContact') {
				// Most recent recentFeedbackDate first; carriers with no contact go last.
				const at = a?.recentFeedbackDate ? new Date(a.recentFeedbackDate).getTime() : 0;
				const bt = b?.recentFeedbackDate ? new Date(b.recentFeedbackDate).getTime() : 0;
				return bt - at;
			}
			if (sort === 'hasRate') {
				// Carriers with an offered rate (desiredPrice) at the top; ties broken by
				// the higher offered rate so the most-prominent ones float up.
				const ahas = a?.desiredPrice != null ? 1 : 0;
				const bhas = b?.desiredPrice != null ? 1 : 0;
				if (bhas !== ahas) return bhas - ahas;
				return (b?.desiredPrice || 0) - (a?.desiredPrice || 0);
			}
			// 'match' — sort by matchScore desc (matches the typical default order)
			return (b?.matchScore || 0) - (a?.matchScore || 0);
		};
	}

	/** CN-8312 V2: Engaged carriers list with the selected sort applied. */
	engagedCarriersSorted$: Observable<any[]> = combineLatest([
		this.projectDetailsStore.engagedCarriersList$,
		this.engagedProcuredSort$,
	]).pipe(
		map(([list, sort]) => (list ? [...list].sort(this.engagedProcuredSortComparator(sort)) : []))
	);

	/** CN-8312 V2: Procured carriers list with the selected sort applied. */
	procuredCarriersSorted$: Observable<any[]> = combineLatest([
		this.projectDetailsStore.procuredCarriersList$,
		this.engagedProcuredSort$,
	]).pipe(
		map(([list, sort]) => (list ? [...list].sort(this.engagedProcuredSortComparator(sort)) : []))
	);

	/** CN-8312 V2: setter wired to the sort popover toggle group. */
	setEngagedProcuredSort(sort: string) {
		this.engagedProcuredSort = sort;
		this.engagedProcuredSort$.next(sort);
		this.persistProjectFilters();
	}

	/**
	 * Handles the Add/Edit Allocation action from the Actions menu.
	 * Gets the selected carrier and opens the allocation configuration dialog.
	 * Works for Recommended tab (using selectedCarrierIds), Allocations tab (using selectedAllocatedCarrierMapIDs),
	 * and Waterfall tab (using selectedProjectCarrierMapIDs).
	 */
	editSelectedCarrierAllocation(): void {
		// Check if we're on the Recommended tab (tab index 0)
		if (this.tabGroup?.selectedIndex === 0) {
			// On Recommended tab, use selectedCarrierIds and capacitySearchResults
			if (this.selectedCarrierIds?.length === 1) {
				const carrierId = this.selectedCarrierIds[0];
				const capacitySearchResults =
					this.recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults || [];
				const carrierResult = capacitySearchResults.find((r: any) => r.carrierId === carrierId);
				const carrierBusinessName = carrierResult?.businessName || 'Unknown Carrier';

				// Skip confirmation dialog since user explicitly clicked Add Allocation
				// Also add the carrier to Waterfall since allocation badges only show there
				this.recommendedCarriersEffects.handleAllocationFlow(
					carrierId,
					carrierBusinessName,
					this.projectId,
					true, // skipConfirmation
					true // addToWaterfall - carrier needs to be in Waterfall for allocation badge to show
				);
			}

			return;
		}

		// On Allocations tab or Waterfall/Procured tab, use the appropriate selection array
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let projectCarrierMap = null,
					selectedPcmId = null;

				// Check Allocations tab selection first
				if (this.selectedAllocatedCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedAllocatedCarrierMapIDs[0];
				} else if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}

				projectCarrierMap = state.allProjectCarrierMapsList.find((pcm) => pcm.id === selectedPcmId);

				if (projectCarrierMap) {
					// Skip confirmation dialog since user explicitly clicked Add/Edit Allocation
					await this.editAllocation(projectCarrierMap, true);
				}
			});
	}

	/**
	 * Handles the Remove Allocation action from the Actions menu.
	 * Gets the selected carrier, removes their allocation, and moves them to another group.
	 *
	 * Logic:
	 * - If only 1 other user group exists (besides current group), move carrier there automatically
	 * - If multiple other groups exist, show dialog to let user choose
	 */
	removeSelectedCarrierAllocation(): void {
		this.store
			.select((state) => state[projectDetailsPageStateKey])
			.pipe(takeUntil(this.isDestroyed$), take(1))
			.subscribe(async (state) => {
				let selectedPcmId = null;

				// Check Allocations tab selection first
				if (this.selectedAllocatedCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedAllocatedCarrierMapIDs[0];
				} else if (this.selectedProjectCarrierMapIDs?.length === 1) {
					selectedPcmId = this.selectedProjectCarrierMapIDs[0];
				} else if (this.projectGroupsComponent?.selectedProjectCarrierMapIds.length === 1) {
					selectedPcmId = this.projectGroupsComponent.selectedProjectCarrierMapIds[0];
				}

				const projectCarrierMap = state.allProjectCarrierMapsList.find(
					(pcm) => pcm.id === selectedPcmId
				);

				if (projectCarrierMap?.carrier) {
					const carrierId = projectCarrierMap.carrier.id;
					const allocation = state.carrierAllocationsMap?.[carrierId];
					const currentGroupId = projectCarrierMap.projectGroup?.id;

					// First, select the target group (before deleting allocation)
					const { projectGroupId: targetGroupId, cancelled } =
						await this.projectGroupService.selectGroupExcludingCurrent(
							state.projectGroups,
							currentGroupId
						);

					if (cancelled || !targetGroupId) {
						// User cancelled or no other groups available
						return;
					}

					// Delete the allocation
					if (allocation?.allocationId) {
						this.store.dispatch(
							PROJECT_DETAILS.ALLOCATIONS.DELETE({
								allocationId: allocation.allocationId,
								projectId: this.projectId,
							})
						);
					}

					// Move the carrier to the target group
					const targetGroup = state.projectGroups.find((g) => g.id === targetGroupId);
					const sourceGroup = state.projectGroups.find((g) => g.id === currentGroupId);

					if (targetGroup && sourceGroup) {
						// Build the update request to move carrier from source to target group
						const targetGroupPcmIds =
							targetGroup.projectCarrierMapsList?.map((pcm) => pcm.id) || [];
						const sourceGroupPcmIds =
							sourceGroup.projectCarrierMapsList
								?.filter((pcm) => pcm.id !== selectedPcmId)
								?.map((pcm) => pcm.id) || [];

						const projectGroupUpdateRequest = {
							projectGroups: [
								{
									projectGroupId: targetGroupId,
									projectCarrierMapIdList: [...targetGroupPcmIds, selectedPcmId],
								},
								{
									projectGroupId: currentGroupId,
									projectCarrierMapIdList: sourceGroupPcmIds,
								},
							],
						};

						// Check if source group will be empty and needs to be deleted
						const deleteGroupIds = sourceGroupPcmIds.length === 0 ? [currentGroupId] : [];

						this.store.dispatch(
							PROJECT_GROUPS.ADD_TO_GROUP.ADD({
								updateGroups: projectGroupUpdateRequest,
								deleteGroupIds,
							})
						);
					}
				}
			});
	}

	/**
	 * Handles the edit allocation event from procured carriers component.
	 * Opens the allocation configuration dialog for the selected carrier.
	 * @param skipConfirmation - If true, skip the decision dialog and go straight to config
	 */
	async editAllocation(
		projectCarrierMap: ProjectCarrierMapDTO,
		skipConfirmation: boolean = false
	): Promise<void> {
		if (!projectCarrierMap?.carrier || !this.isWaterfallOrDedicatedLaneProject) {
			return;
		}

		const carrierId = projectCarrierMap.carrier.id;
		const carrierBusinessName = projectCarrierMap.carrier.businessName;

		// When adding allocation to carrier already in waterfall, move them to lowest priority group
		// This ensures allocated carriers get last priority in waterfall after their allocation window
		await this.recommendedCarriersEffects.handleAllocationFlow(
			carrierId,
			carrierBusinessName,
			this.projectId,
			skipConfirmation,
			false, // addToWaterfall - carrier is already in waterfall
			true, // moveToLowestPriorityGroup - move to lowest priority group after allocation
			projectCarrierMap.id // projectCarrierMapId - needed to move the carrier
		);
	}

	// CN-8312: V3 Ribbon Menu handlers
	onRibbonItemClicked(itemId: string): void {

		if (this.activeRibbonItem === itemId) {
			// Toggle off if same item clicked
			this.closeRibbonTray();
		} else {
			// Open tray with new content
			this.activeRibbonItem = itemId;
			this.isRibbonTrayOpen = true;
			this.ribbonTrayTitle = this.getRibbonTrayTitle(itemId);
		}
	}

	closeRibbonTray(): void {
		this.isRibbonTrayOpen = false;
		this.activeRibbonItem = null;
		this.ribbonTrayTitle = '';
	}

	private getRibbonTrayTitle(itemId: string): string {

		const titles: { [key: string]: string } = {
			project: 'Project Details',
			notes: 'Notes',
			tasks: 'Tasks',
			quality: 'Carrier',
		};

		return titles[itemId] || '';
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		this.projectDetailsStore.clear();
		this.store.dispatch(PROJECT_DETAILS.RESET_STATE({}));
	}

	persistProjectFilters() {
		if (
			this.utilService.isNullOrUndefined(this.projectId) ||
			this.rehydratedProjectId !== this.projectId
		) {
			return;
		}
		let projectFilters: { [projectId: string]: any } = {};
		const stored = this.cargochief.getItem(CARGOCHIEF_KEYS.PROJECT_DETAILS_FILTERS);
		if (stored) {
			try {
				projectFilters = JSON.parse(stored) || {};
			} catch {
				projectFilters = {};
			}
		}
		projectFilters[this.projectId] = {
			...this.carrierFiltersModel,
			engagedProcuredSort: this.engagedProcuredSort,
			showValidatedContactsOnly: this.showValidatedContactsOnly,
			activeTabIndex: this.tabGroup?.selectedIndex,
		};
		this.cargochief.setItem({ [CARGOCHIEF_KEYS.PROJECT_DETAILS_FILTERS]: projectFilters });
	}

	/** Restore this project's saved filter/sort/tab selections and re-run filtering. */
	rehydrateProjectFilters() {
		if (
			this.utilService.isNullOrUndefined(this.projectDTO) ||
			this.utilService.isNullOrUndefined(this.projectId) ||
			this.rehydratedProjectId === this.projectId
		) {
			return;
		}
		this.rehydratedProjectId = this.projectId;

		const stored = this.cargochief.getItem(CARGOCHIEF_KEYS.PROJECT_DETAILS_FILTERS);
		if (!stored) {
			this.resetProjectFiltersToDefault();
			return;
		}
		let projectFilters: { [projectId: string]: any } = {};
		try {
			projectFilters = JSON.parse(stored) || {};
		} catch {
			this.cargochief.removeItem(CARGOCHIEF_KEYS.PROJECT_DETAILS_FILTERS);
			this.resetProjectFiltersToDefault();
			return;
		}
		const snapshot = projectFilters[this.projectId];
		if (this.utilService.isNullOrUndefined(snapshot)) {
			this.resetProjectFiltersToDefault();
			return;
		}
		this.currentProjectHasSavedFilters = true;

		const { engagedProcuredSort, showValidatedContactsOnly, activeTabIndex, ...filters } = snapshot;
		this.carrierFiltersModel = { ...this.carrierFiltersModel, ...filters };
		this.showValidatedContactsOnly = !!showValidatedContactsOnly;
		if (this.tabGroup && !this.utilService.isNullOrUndefined(activeTabIndex)) {
			this.tabGroup.selectedIndex = activeTabIndex;
			this.restoredActiveTab = true;
		}

		// Deadhead + frequency are read from these global keys by the capacity search on load.
		this.cargochief.setItem({
			[CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER]: this.carrierFiltersModel.originDeadhead,
			[CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER]: this.carrierFiltersModel.destinationDeadhead,
			[CARGOCHIEF_KEYS.FREQUENCY_FILTER]: { minLoadsPerWeek: this.carrierFiltersModel.minLoadsPerWeek },
		} as { [keyName: string]: Object });
		this.store.dispatch(
			RECOMMENDED_CARRIERS.SET.CAPACITY_SEARCH_SORT({
				capacitySearchSort: this.carrierFiltersModel.capacitySearchSort,
			})
		);
		this.setEngagedProcuredSort(engagedProcuredSort || this.engagedProcuredSort);
		this.setClientFiltersForCarriers();
		this.store.dispatch(PROJECT_CARRIER_MAP.FILTER.APPLY({}));
		this.projectDetailsEffects.sortSearchList(this.carrierFiltersModel.capacitySearchSort);
		this.reapplyFiltersOnDataLoad();
	}

	reapplyFiltersOnDataLoad() {
		if (this.filtersReapplyBound) {
			return;
		}
		this.filtersReapplyBound = true;
		this.actions$
			.pipe(
				ofType(
					RECOMMENDED_CARRIERS.SEARCH_LANES_SUCCESS,
					PROJECT_CARRIER_MAP.SET.ALL_PROJECT_CARRIER_MAPS_LIST,
					RECOMMENDED_CARRIERS.SET.MATCHED_CARRIER_HQ_IDS
				),
				takeUntil(this.isDestroyed$),
				debounceTime(250)
			)
			.subscribe(() => {
				if (!this.currentProjectHasSavedFilters) {
					return;
				}
				this.store.dispatch(PROJECT_CARRIER_MAP.FILTER.APPLY({}));
				this.projectDetailsEffects.sortSearchList(this.carrierFiltersModel.capacitySearchSort);
			});
	}

	resetProjectFiltersToDefault() {
		this.carrierFiltersModel = {
			...this.carrierFiltersModel,
			powerUnits: 0,
			minLoadsPerWeek: 0,
			ratesOnly: false,
			carriersSearchText: '',
			carrierHQ: '',
			carrierSelected: 'All Carriers',
			capacitySearchSort: RANGE_FILTERS.SORT.MATCH,
			qualityFilter: '',
		};
		this.showValidatedContactsOnly = false;
		this.engagedProcuredSort = RANGE_FILTERS.SORT.MATCH;
		this.engagedProcuredSort$.next(RANGE_FILTERS.SORT.MATCH);
		this.setClientFiltersForCarriers();
	}

	updateFilterIndicator() {
		this.filterIndicator = this.capacitySearchFilterService.getFilterIndicator(
			this.carrierFiltersModel,
			{
				originDeadhead: this.defaultOriginDeadhead,
				destinationDeadhead: this.defaultDestinationDeadhead,
				powerUnits: 0,
				minLoadsPerWeek: 0,
			}
		);
	}

	clearFilters() {
		if (!this.filterIndicator) {
			return;
		}
		this.carrierFiltersModel = {
			...this.carrierFiltersModel,
			originDeadhead: this.defaultOriginDeadhead,
			destinationDeadhead: this.defaultDestinationDeadhead,
			powerUnits: 0,
			minLoadsPerWeek: 0,
			ratesOnly: false,
			carriersSearchText: '',
			carrierHQ: '',
			carrierSelected: 'All Carriers',
			qualityFilter: '',
		};
		this.cargochief.setItem({
			[CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER]: this.defaultOriginDeadhead,
			[CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER]: this.defaultDestinationDeadhead,
			[CARGOCHIEF_KEYS.FREQUENCY_FILTER]: { minLoadsPerWeek: 0 },
		} as { [keyName: string]: Object });
		this.applyFilter();
	}
}
